var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollectingRightImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 119,
    viewBox: "0 0 259 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.42 0.849609H175.689V55.5796H230.42V0.849609Z",
    fill: "#FFC9C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M203.05 53.4696C217.194 53.4696 228.66 42.0036 228.66 27.8596C228.66 13.7156 217.194 2.24963 203.05 2.24963C188.906 2.24963 177.439 13.7156 177.439 27.8596C177.439 42.0036 188.906 53.4696 203.05 53.4696Z",
    stroke: "#FF6B6B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M194.309 29.8396C193.819 29.5996 194.069 28.8596 194.019 28.3196C193.939 27.4196 192.809 26.9296 191.929 27.1696C191.059 27.4096 190.399 28.1196 189.799 28.7996C190.949 29.2496 191.739 30.3496 192.219 31.4996C192.709 32.6396 192.959 33.8696 193.439 35.0096C193.809 35.8996 194.319 36.7196 194.819 37.5396C195.449 38.5596 196.069 39.5796 196.699 40.5896C197.089 41.2196 197.489 41.9096 197.459 42.6496C197.439 43.0196 197.319 43.3796 197.189 43.7396C196.599 45.3896 195.999 47.0396 195.409 48.6996C195.839 48.7596 196.269 48.9096 196.639 49.1396C196.829 49.2596 197.019 49.3996 197.229 49.4896C197.519 49.6196 197.839 49.6596 198.159 49.6896C199.819 49.8696 201.599 50.0296 203.079 49.2596C203.509 49.0396 203.929 48.7296 204.419 48.6996C204.999 48.6596 205.559 49.0296 206.139 48.9696C206.839 47.8296 207.829 46.8696 208.999 46.2096C207.439 45.0896 205.889 43.9696 204.329 42.8596C203.649 42.3696 202.939 41.8496 202.559 41.0996C202.179 40.3496 202.259 39.2896 202.949 38.8196C203.719 39.2296 204.639 39.3496 205.489 39.1596C205.969 39.0496 206.429 38.8396 206.929 38.8096C207.499 38.7696 208.059 38.9696 208.629 38.9596C209.429 38.9296 210.139 38.4896 210.799 38.0296C213.039 36.4796 215.109 34.6796 216.959 32.6696C218.529 30.9596 219.969 29.0396 220.619 26.8096C220.809 26.1296 220.929 25.4396 221.179 24.7796C221.529 23.8396 222.139 22.9896 222.929 22.3596C223.449 21.9396 224.049 21.6196 224.499 21.1296C224.949 20.6396 225.229 19.8996 224.939 19.2996C224.749 18.8896 224.339 18.6296 224.069 18.2696C223.679 17.7596 223.589 17.0996 223.379 16.4896C223.009 15.3896 222.239 14.4396 221.249 13.8396C221.859 13.3996 221.649 12.3996 221.129 11.8396C220.609 11.2896 219.889 10.9596 219.419 10.3696C219.179 10.0696 218.999 9.69962 218.689 9.45962C218.299 9.16962 217.759 9.13962 217.389 8.83962C217.169 8.65962 217.029 8.38962 216.869 8.14962C216.309 7.28962 215.419 6.63962 214.429 6.35962C213.039 7.51962 211.799 8.84962 210.739 10.3096C210.659 9.85962 210.459 9.41962 210.169 9.05962C210.499 10.7996 209.369 12.4396 208.309 13.8496C207.039 15.5196 205.779 17.1996 204.509 18.8696C203.719 17.0796 202.539 15.4496 201.079 14.1396C200.909 13.9796 200.719 13.8196 200.639 13.6096C200.519 13.2896 200.639 12.9296 200.719 12.5896C201.089 10.9496 200.089 9.11962 198.519 8.52962C198.889 6.94962 197.349 5.22962 195.729 5.43962C195.379 5.47962 195.039 5.59962 194.689 5.56962C194.279 5.53962 193.909 5.30962 193.509 5.22962C192.509 5.01962 191.449 5.91962 191.469 6.92962C190.759 6.84962 190.029 7.09962 189.519 7.58962C189.259 7.83962 189.049 8.14962 188.769 8.36962C188.279 8.75962 187.629 8.85962 187.069 9.13962C186.509 9.41962 186.019 10.0696 186.289 10.6396C185.309 10.1796 184.219 11.3996 184.339 12.4796C184.459 13.5596 185.269 14.4196 185.969 15.2496C187.859 17.4896 189.219 20.1596 189.919 22.9996C189.919 22.9996 192.489 23.7996 192.739 23.9396C193.629 24.4396 194.429 25.0896 195.099 25.8596C195.779 26.6496 196.329 27.5496 196.689 28.5296C196.849 28.9596 197.669 31.3996 196.489 30.8796C196.079 30.6996 196.149 30.0696 195.819 29.7696C195.409 29.3696 194.699 29.3796 194.309 29.8396Z",
    fill: "#FFA8A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.96 27.4396C193.11 26.9596 191.96 27.0696 191.23 27.7096C190.95 27.9496 190.66 28.2796 190.3 28.2496C190.14 28.2296 189.99 28.1396 189.82 28.1396C189.53 28.1396 189.31 28.4296 189.28 28.7196C189.25 29.0096 189.37 29.2896 189.48 29.5596C189.77 29.0796 190.25 28.5296 190.77 28.7296C191.15 28.8796 191.35 29.3896 191.76 29.4096",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M190.789 28.8396C191.279 30.2996 192.139 31.6396 193.259 32.6896",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M193.719 28.1296C193.799 29.1796 194.089 30.2196 194.559 31.1596",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M194.629 30.3396C194.679 29.9996 195.099 29.7896 195.429 29.8896C195.759 29.9896 195.989 30.2996 196.079 30.6396C196.169 30.9696 196.139 31.3296 196.119 31.6696C196.079 32.1296 196.049 32.5896 196.009 33.0396",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M192.589 32.3296C192.349 32.9596 192.439 33.7096 192.829 34.2696C193.219 34.8296 193.89 35.1796 194.56 35.1696",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M193.999 34.6696C193.719 35.0696 193.919 35.6296 194.129 36.0696C194.379 36.5996 194.629 37.1296 194.879 37.6696C195.449 38.8696 196.169 40.2096 197.469 40.5296",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M194.879 34.6696C195.309 35.7896 195.829 36.8796 196.439 37.9196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M191.989 28.8196C191.879 28.4796 192.339 28.1896 192.679 28.3096C193.009 28.4296 193.209 28.7696 193.369 29.0796",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M196.189 30.8096C196.879 31.3896 197.95 31.3196 198.74 30.8696C199.53 30.4196 200.1 29.6896 200.65 28.9696C201.4 27.9996 202.149 27.0196 202.719 25.9296C203.899 23.6996 204.29 21.1196 205.42 18.8596C207.06 15.5596 210.3 12.7896 210.26 9.10962C211.19 10.2596 211.29 12.0096 210.5 13.2696C211.61 10.7896 213.06 8.45962 214.79 6.35962",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M215.91 7.47961C214.57 9.55961 213.33 11.6996 212.18 13.8996",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M217.669 9.5896C216.029 11.1396 214.479 12.7796 213.029 14.5096",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M219.14 10.5796C217.32 12.0296 215.5 13.4696 213.68 14.9196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M220.24 12.0496C217.8 13.4996 215.48 15.1596 213.32 17.0096",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M221.059 12.8696C218.469 14.1396 216.009 15.6696 213.719 17.4196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M222.58 14.0396C219.82 15.9996 216.82 17.6196 213.68 18.8696",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M223.95 17.3696C222.45 17.5596 220.95 17.7596 219.45 17.9496C217.23 18.2296 214.95 18.5396 212.98 19.5996",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M223.849 18.8496C220.509 19.3396 217.209 20.1896 214.039 21.3596",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M224.78 20.2096C223.34 20.6196 221.9 21.0196 220.46 21.4296C218.78 21.9096 217.08 22.3796 215.33 22.4396",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M200.779 35.9996C201.309 36.8096 201.909 37.5696 202.569 38.2696C203.049 38.7696 203.699 39.2796 204.359 39.0796",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M203.119 34.7596C204.049 36.9696 206.279 38.5696 208.679 38.7496",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M205.18 34.6596C206.29 36.4696 208.31 37.6996 210.43 37.8496",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M206.93 33.4896C207.68 34.3296 208.45 35.1996 209.45 35.7396C210.44 36.2796 211.71 36.4496 212.69 35.8796",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M208.309 31.2896C209.209 32.1696 210.129 33.0496 211.229 33.6496C212.329 34.2496 213.669 34.5396 214.859 34.1396",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M209.869 29.4996C210.849 30.4996 211.849 31.5196 213.099 32.1496C214.349 32.7796 215.909 32.9696 217.129 32.2696",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M209.68 27.8196C211.91 30.0396 215.27 31.0696 218.36 30.4696",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M210.529 26.0496C212.929 27.7196 215.899 28.5696 218.819 28.4196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M211.369 25.1796C212.539 26.2896 214.189 26.7996 215.799 26.8596C217.409 26.9296 219.009 26.5896 220.579 26.2096",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M214.4 24.4896C216.39 25.2596 218.62 25.3996 220.7 24.8796",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M216.029 23.8196C217.049 23.8196 218.009 24.3696 219.029 24.3896C219.889 24.3996 220.709 24.0396 221.499 23.6796",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M185.119 13.0696C187.319 15.4396 188.849 18.4296 189.489 21.5996C189.579 22.0596 189.679 22.5796 190.049 22.8696C190.269 23.0396 190.549 23.1096 190.819 23.1896C194.119 24.1196 196.709 27.1796 197.089 30.5796",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M186.82 10.4496C188.2 11.9796 189.25 13.8196 189.85 15.7996C190.31 17.3196 190.53 18.9296 191.26 20.3396",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M188.48 9.12964C190.88 12.0296 191.47 15.9796 191.96 19.7096C191.97 19.4796 191.99 19.2596 192 19.0296",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M190.389 7.34961C192.079 10.7096 192.999 14.4496 193.049 18.2096",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M193.42 6.09961C194.36 10.1196 194.73 14.2796 194.52 18.4096C194.57 18.2696 194.63 18.1196 194.68 17.9796",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M195.279 5.63959C196.479 9.77959 196.689 14.1996 195.879 18.4296C195.869 18.3196 195.859 18.2096 195.849 18.0996",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M197.779 5.1496C197.959 6.6196 198.139 8.0896 198.309 9.5696C198.659 12.6896 198.929 16.0496 197.389 18.7896C197.699 18.5596 197.929 18.2196 198.049 17.8496",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M200.139 9.45959C200.449 13.5196 200.049 17.6396 198.959 21.5696C198.969 21.4596 198.979 21.3596 198.989 21.2496",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M202.14 16.4596C202.25 17.0896 202.03 17.7296 201.82 18.3396C201.05 20.4996 200.28 22.6596 199.51 24.8196C199.67 24.8396 199.82 24.6896 199.8 24.5296",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M203.789 18.9196C203.959 19.1196 203.829 19.4296 203.699 19.6496C202.699 21.3596 201.699 23.0696 200.699 24.7796C200.869 24.6096 201.039 24.4496 201.209 24.2796",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M200.869 13.8696C201.539 14.3096 202.009 14.9896 202.469 15.6396C203.529 17.1596 204.599 18.6996 205.379 20.3796",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M202.389 39.0996C202.429 38.9996 202.549 38.9396 202.659 38.9496C202.389 39.5596 202.239 40.2296 202.209 40.8996C203.979 42.3596 205.749 43.8096 207.519 45.2696",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M196.4 38.9796C196.54 40.3296 197.28 41.5996 198.37 42.3996C198.54 42.5196 198.72 42.6396 198.86 42.7896C199.15 43.0996 199.26 43.5196 199.47 43.8796C199.68 44.2396 200.1 44.5596 200.49 44.4196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M197.89 42.0396C197.04 43.9196 196.29 45.8596 195.66 47.8196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M198.739 43.5196C198.039 45.3496 197.479 47.2296 197.059 49.1396",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M200.45 44.2396C200.13 45.8996 199.98 47.5996 200 49.2996C200 49.3796 200.02 49.4896 200.1 49.5096C200.18 49.5196 200.16 49.3396 200.1 49.3996",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M201.18 43.7696C201.59 45.3896 202.26 46.9296 203.18 48.3296",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M201.42 42.1396C202.34 43.9896 203.61 45.6696 205.15 47.0596",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M195.15 48.1796C195.37 48.3896 195.7 48.4296 196 48.4496C196.3 48.4696 196.63 48.4796 196.88 48.6496C197.13 48.8296 197.23 49.2396 196.99 49.4296C198.35 49.5096 199.71 49.5896 201.08 49.6696C201.74 49.7096 202.49 49.7096 202.94 49.2396C203.1 49.0696 203.21 48.8496 203.39 48.7096C204.11 48.1296 205.24 49.0996 206.08 48.7196C206.57 48.4996 206.76 47.9196 207.15 47.5396C207.75 46.9496 208.87 46.8096 209.04 45.9896",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M209.49 45.0296C210.08 44.7796 210.6 44.3096 211.23 44.2496C212.03 44.1696 212.82 44.8796 212.83 45.6896C212.84 46.4996 212.07 47.2196 211.26 47.1596",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M210.15 44.7096C210.48 45.7096 210.81 46.7196 211.14 47.7196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M212.42 43.5396C212.97 42.9896 213.59 42.4996 214.25 42.0896",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M213.109 43.0596C213.209 43.9696 213.889 44.6996 214.389 45.4796C214.459 45.5896 214.529 45.6996 214.519 45.8296C214.509 45.9596 214.399 46.0796 214.269 46.0496C214.829 45.6196 215.389 45.1796 215.949 44.7496",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M214.509 43.5296C214.189 43.8396 213.879 44.1396 213.559 44.4496",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M216.849 39.9296C216.949 39.8796 216.789 39.7596 216.679 39.7896C216.019 39.9796 215.889 40.9396 216.249 41.5296C216.609 42.1096 217.319 42.4596 217.999 42.3896C218.679 42.3196 219.299 41.8396 219.539 41.1996",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M217.9 37.9196C218.8 38.6496 219.7 39.3896 220.61 40.1196C220.64 40.0796 220.68 40.0396 220.71 40.0096",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M219.279 38.9696C219.679 38.5996 219.989 38.1296 220.179 37.6096",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M219.41 37.2296C219.12 37.1096 218.91 36.8396 218.85 36.5296C219.65 37.2696 220.52 37.9296 221.45 38.4896",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M219.869 34.8896C219.759 35.0896 219.649 35.2996 219.539 35.4996C219.639 35.3796 219.729 35.2596 219.829 35.1396C219.699 35.4296 219.519 35.6896 219.279 35.8996C219.369 35.5296 219.849 35.3896 220.209 35.5096C220.569 35.6296 220.839 35.9096 221.129 36.1596C221.609 36.5696 222.169 36.8896 222.769 37.0996C222.759 36.7596 222.789 36.4096 222.859 36.0796C222.669 36.4796 222.449 36.8596 222.199 37.2296",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M220.439 33.0196C220.359 33.3596 220.279 33.6996 220.199 34.0296C220.379 33.7296 220.829 33.8396 221.149 33.9996C221.869 34.3596 222.569 34.7696 223.229 35.2096C223.229 34.5596 223.339 33.9096 223.559 33.2896C223.589 33.2096 223.649 33.1096 223.729 33.1196C223.819 33.1396 223.709 33.2996 223.689 33.2196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M221 29.8696C220.91 30.4596 220.82 31.0496 220.73 31.6296C221.3 31.6796 221.861 31.7196 222.431 31.7696C222.981 31.8196 223.59 31.8796 223.98 32.2796C223.87 31.5496 223.941 30.7896 224.181 30.0896C224.061 29.8696 223.85 29.6996 223.61 29.6496",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M222.36 30.2296C222.32 30.8096 222.27 31.3996 222.23 31.9796",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M198.5 32.6896C198.69 33.6196 199.95 34.1396 200.74 33.6096",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M200.469 31.8596C200.589 32.2996 200.759 32.7596 201.139 33.0096C201.519 33.2596 202.159 33.1296 202.249 32.6796",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M201.73 30.7996C201.86 31.3096 202.58 31.5296 202.98 31.1896",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M203.119 29.0396C203.369 29.3896 203.929 29.4696 204.259 29.1996",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M204.369 27.6596C204.509 27.7696 204.709 27.8096 204.889 27.7596C204.709 27.7196 204.529 27.6896 204.369 27.6596Z",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M204.719 26.1296C205.049 26.2796 205.439 26.2996 205.769 26.1596",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M205.66 24.1496C205.9 24.3296 206.28 24.2796 206.46 24.0496",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M206.119 22.5196C206.269 22.6696 206.539 22.6796 206.689 22.5296",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M206.459 21.3696C206.649 21.2896 206.849 21.2196 207.039 21.1396",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M206.93 19.4996C207.09 19.3996 207.25 19.2996 207.41 19.2096C207.25 19.3096 207.09 19.3996 206.93 19.4996Z",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M203.299 33.1496C203.249 33.0596 203.159 32.9996 203.059 32.9996C203.079 33.3496 203.368 33.6696 203.708 33.7196C204.058 33.7796 204.428 33.5796 204.568 33.2496",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M204.379 31.7396C204.519 32.1996 205.219 32.3496 205.539 31.9896",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M205.289 31.0496C205.679 31.0496 206.069 31.0496 206.459 31.0496",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M206.129 29.1596C206.469 29.4796 207.049 29.4996 207.419 29.2196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M207.039 27.3096C207.309 27.3096 207.579 27.3096 207.859 27.3096",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M207.559 25.8896C207.759 26.3496 208.339 26.5896 208.809 26.4196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M208.34 24.1496C208.6 24.3396 208.96 24.4096 209.27 24.3296",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M208.67 22.0796C209.1 22.2396 209.63 21.9296 209.7 21.4696",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M209.26 20.5296C209.6 20.5396 209.94 20.4296 210.21 20.2196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M208.91 19.0296C209.18 18.8696 209.45 18.7196 209.73 18.5596",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M198.539 38.5096C198.879 39.1796 199.149 39.8896 199.339 40.6196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M198.389 40.6196C198.579 41.3296 199.309 41.8396 200.039 41.7796",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M199.82 38.9696C200.33 39.6196 200.69 40.3896 200.86 41.1896",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M182.649 21.9396C182.539 22.2396 182.429 22.5396 182.319 22.8496C182.259 22.6496 182.539 22.5396 182.739 22.5296C183.519 22.4796 184.309 22.5196 185.089 22.6496C185.139 23.0096 185.179 23.3796 185.079 23.7296C184.979 24.0796 184.719 24.3996 184.369 24.4796C183.849 24.5896 183.319 24.0096 183.469 23.4996",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M183.589 22.8796C183.769 23.7596 182.859 24.6796 181.979 24.5096C181.919 24.6996 181.869 24.8896 181.809 25.0796",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M181.699 25.9596C182.779 26.1296 183.879 26.2296 184.979 26.2496C185.099 26.2296 184.969 26.0196 184.869 26.0696C184.759 26.1196 184.749 26.2696 184.749 26.3896C184.759 26.8896 184.769 27.3896 184.779 27.8896",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M183.129 26.6096C183.129 26.9596 183.129 27.3096 183.129 27.6596",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M181.61 26.3796C181.58 27.0796 181.63 27.7796 181.75 28.4796",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M181.859 29.4896C182.829 29.3496 183.799 29.1996 184.779 29.0596C184.849 29.4496 184.909 29.8496 184.819 30.2296C184.729 30.6096 184.429 30.9696 184.039 31.0196C183.669 31.0596 183.319 30.7996 183.139 30.4796C182.959 30.1596 182.899 29.7796 182.849 29.4096",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M185.1 32.2196C185.04 32.0696 184.99 31.9096 184.93 31.7596C184.93 32.2396 184.38 32.4996 183.91 32.5796C183.44 32.6596 182.89 32.7096 182.63 33.1096C182.36 33.3696 182.56 33.8696 182.9 34.0196C183.24 34.1696 183.64 34.0796 184 33.9896C184.49 33.8696 184.98 33.7396 185.47 33.6196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M185.959 35.0796C185.239 35.4796 184.509 35.8796 183.789 36.2796C183.659 36.3496 183.519 36.4296 183.449 36.5596C183.369 36.7096 183.399 36.8996 183.459 37.0696C183.639 37.5596 184.099 37.9896 184.619 37.9796C185.139 37.9696 185.629 37.4196 185.459 36.9196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M185.25 35.4696C185.17 35.3896 185.02 35.4596 184.98 35.5596C184.94 35.6696 184.97 35.7896 185 35.8996C185.09 36.1796 185.19 36.4696 185.39 36.6796C185.59 36.8896 185.93 36.9996 186.19 36.8696C186.49 36.7196 186.58 36.3096 186.47 35.9896C186.36 35.6696 186.1 35.4296 185.84 35.2096",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M187.15 37.8996C187.19 37.9296 187.19 37.8196 187.15 37.8396C186.38 38.3696 185.61 38.8896 184.84 39.4096C184.74 39.3496 184.66 39.2396 184.65 39.1096C185.01 39.7896 185.45 40.4396 185.94 41.0396",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M188.559 40.3196C187.719 41.0396 186.959 41.8396 186.289 42.7296",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M188.37 40.7296C188.23 40.5296 188.09 40.3296 187.95 40.1296C188.17 40.1996 188.37 40.2996 188.55 40.4396C188.34 40.3396 188.12 40.2396 187.91 40.1396",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M186.4 42.4696C186.26 42.4396 186.16 42.3096 186.15 42.1696C186.32 42.3796 186.46 42.6196 186.56 42.8796C186.5 42.7496 186.45 42.6196 186.39 42.4896",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M191.369 42.4196C190.819 41.6896 189.649 41.5396 188.939 42.0996C188.489 42.4496 188.239 43.0196 188.229 43.5896C188.219 43.9796 188.319 44.3796 188.589 44.6596C188.859 44.9396 189.309 45.0596 189.649 44.8796",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M190.359 46.1396C191.049 45.1596 191.929 44.3096 192.939 43.6496C192.849 44.9496 192.629 46.2496 192.279 47.5096",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M191.07 44.7896C191.41 44.9296 191.73 45.1396 191.99 45.3996",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M183.959 14.4896C183.479 14.9796 183.039 15.5196 182.669 16.0896C182.329 15.8696 181.989 15.6396 181.639 15.4196C181.399 15.8896 181.159 16.3496 180.909 16.8196C181.239 16.7696 181.519 17.0896 181.559 17.4196C181.599 17.7496 181.449 18.0696 181.309 18.3696C181.089 18.8396 180.869 19.3196 180.649 19.7896C180.649 19.4696 180.509 19.1396 180.289 18.9096C180.049 19.1696 179.799 19.4496 179.719 19.7896C179.639 20.1296 179.809 20.5696 180.159 20.6396C180.279 20.6596 180.419 20.6596 180.489 20.7596C180.539 20.8396 180.519 20.9496 180.489 21.0396C180.299 21.6496 180.099 22.2596 179.909 22.8596C179.789 22.5696 179.409 22.4196 179.119 22.5496C178.829 22.6796 178.689 23.0596 178.809 23.3496C178.969 23.7396 179.459 23.8596 179.879 23.9196C179.799 24.6196 179.709 25.3196 179.629 26.0196C179.709 25.9396 179.789 25.8696 179.869 25.7896",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M198.279 4.99962C198.689 5.04962 199.109 5.10962 199.519 5.15962C199.849 5.19962 200.199 5.23962 200.489 5.08962C200.779 4.93962 200.949 4.50962 200.719 4.26962C201.159 4.18962 201.619 4.18962 202.059 4.27962C201.879 4.50962 202.269 4.75962 202.559 4.78962C203.449 4.89962 204.329 5.00962 205.219 5.10962C205.299 4.73962 205.329 4.36962 205.299 3.98962C205.919 3.92962 206.549 4.00962 207.129 4.22962C207.259 4.47962 207.219 4.79962 207.039 5.00962C207.739 5.27962 208.459 5.47962 209.189 5.59962C209.229 5.38962 209.259 5.17962 209.299 4.96962C209.689 4.74962 210.239 4.77962 210.529 5.11962C210.819 5.45962 210.699 6.08962 210.269 6.21962C211.129 6.55962 212.019 6.82962 212.919 7.01962C212.869 6.70962 212.939 6.38962 213.109 6.12962C213.619 6.29962 214.109 6.51962 214.569 6.79962",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M210.539 50.0496C211.159 49.9096 211.749 49.6796 212.299 49.3596C212.379 49.6696 212.449 49.9796 212.529 50.2896C212.979 50.1996 213.409 49.9996 213.759 49.7196C213.619 49.4196 213.409 49.1396 213.159 48.9296C213.809 48.5096 214.499 48.1396 215.209 47.8296C215.279 48.1296 215.439 48.4196 215.649 48.6496C216.139 48.4496 216.609 48.1896 217.039 47.8796C216.729 47.6596 216.509 47.3296 216.409 46.9596C217.069 46.5796 217.729 46.1896 218.399 45.8096C218.429 46.0896 218.469 46.3696 218.499 46.6496C218.919 46.4196 219.349 46.1896 219.769 45.9596C219.589 45.7196 219.409 45.4796 219.229 45.2496C219.889 44.5996 220.549 43.9496 221.199 43.2996C221.359 43.4896 221.459 43.7396 221.469 43.9896C221.789 43.7096 222.109 43.4396 222.429 43.1596C222.209 42.8196 221.909 42.5396 221.549 42.3496C222.059 41.5896 222.579 40.8296 223.089 40.0796C223.309 40.2096 223.519 40.3396 223.739 40.4696C223.969 40.1196 224.199 39.7696 224.419 39.4196C224.079 39.2696 223.729 39.1196 223.389 38.9796C223.679 38.3596 223.969 37.7396 224.249 37.1196C224.619 37.1996 224.989 37.2696 225.359 37.3496",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M180.68 37.5796C181.01 37.5596 181.34 37.4496 181.62 37.2696C181.71 37.8996 181.94 38.4996 182.29 39.0296C181.96 38.9496 181.65 39.3296 181.67 39.6696C181.69 40.0096 181.91 40.3096 182.12 40.5796C182.45 40.4096 182.77 40.2396 183.1 40.0696C183.57 40.4996 183.97 40.9996 184.29 41.5596C183.92 41.8696 183.54 42.1796 183.17 42.4896C183.32 42.7496 183.47 42.9996 183.61 43.2596C184.16 42.9996 184.83 43.1896 185.31 43.5596C185.79 43.9296 186.11 44.4696 186.42 44.9896C186.14 45.1496 185.9 45.3796 185.71 45.6496C185.95 45.8696 186.18 46.0796 186.42 46.2996C186.71 46.1796 186.97 45.9896 187.18 45.7596C187.98 46.2096 188.72 46.7596 189.39 47.3796C189.21 47.6396 189.02 47.8896 188.84 48.1496C189.1 48.4596 189.47 48.6796 189.87 48.7496C190.06 48.4596 190.25 48.1596 190.44 47.8696C191.32 48.1996 192.13 48.7196 192.81 49.3696C192.65 49.6496 192.48 49.9296 192.32 50.2096C192.62 50.4396 193 50.5396 193.37 50.4896C193.46 50.2596 193.55 50.0196 193.64 49.7896C194.33 49.7296 195.06 49.6796 195.68 49.9796C196.3 50.2796 196.74 51.0796 196.41 51.6896C196.84 51.6796 197.27 51.6796 197.7 51.6696C197.8 51.3496 197.9 51.0396 198 50.7196C198.61 50.5596 199.24 50.3896 199.85 50.5496C200.46 50.7096 201 51.2896 200.88 51.9096C201.34 51.8296 201.81 51.7896 202.27 51.7896",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M195.939 34.3196C196.139 34.8496 196.68 35.2396 197.25 35.2496",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M196.879 34.0896C197.549 34.7096 198.359 35.1896 199.229 35.4596",
    stroke: "#FF6B6B",
    strokeWidth: 0.9409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7906 65.3192L25.1406 57.4492L21.1406 66.2792L30.7906 65.3192Z",
    stroke: "#FF6B6B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M245.041 73.0902C244.701 73.0902 244.361 72.9602 244.101 72.7002C243.581 72.1802 243.581 71.3402 244.101 70.8202L246.541 68.3802C247.061 67.8602 247.901 67.8602 248.421 68.3802C248.941 68.9002 248.941 69.7402 248.421 70.2602L245.981 72.7002C245.721 72.9602 245.381 73.0902 245.041 73.0902Z",
    stroke: "#FF6B6B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M252.23 90.3398C253.611 90.3398 254.73 89.2206 254.73 87.8398C254.73 86.4591 253.611 85.3398 252.23 85.3398C250.85 85.3398 249.73 86.4591 249.73 87.8398C249.73 89.2206 250.85 90.3398 252.23 90.3398Z",
    stroke: "#FF6B6B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4003 36.7009L27.9902 28.3809",
    stroke: "#FF6B6B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9934 6.62555L39.8594 5.00586L38.2397 9.13994L42.3737 10.7596L43.9934 6.62555Z",
    stroke: "#FF6B6B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M257.859 4.50984L252.309 0.589844L251.699 7.34984L257.859 4.50984Z",
    stroke: "#FF6B6B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M111.4 61.6504H56.25V116.8H111.4V61.6504Z",
    fill: "#FFC9C9"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4503 64.6604H77.1903L65.7103 71.2904L59.0703 82.7804V96.0404L65.7103 107.52L77.1903 114.16H90.4503L101.94 107.52L108.57 96.0404V82.7804L101.94 71.2904L90.4503 64.6604Z",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.25 0.25"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3205 78.1104C74.7805 79.6104 74.7305 81.2404 74.4205 82.8004C73.9005 85.4004 72.6505 87.8004 71.2805 90.0704C71.1105 90.3504 70.9406 90.6704 71.0506 90.9704C71.1406 91.2004 71.3706 91.3504 71.5606 91.5004C72.7706 92.4604 72.8805 94.2104 73.0205 95.7504C73.1705 97.2904 73.6705 99.0904 75.1405 99.5604C76.0105 99.8404 76.9605 99.5504 77.8705 99.6904C79.6205 99.9604 80.7205 101.74 81.2005 103.44C81.7105 105.27 81.7805 107.22 81.4005 109.07C82.7205 108.8 83.8505 108 84.9905 107.27C87.8005 105.48 90.8505 104.06 94.0305 103.06C92.8405 100.07 91.9906 96.7304 92.9306 93.6504C93.2906 92.4604 93.9105 91.3604 94.5005 90.2604C95.6205 88.1704 96.6805 86.0104 97.1505 83.6904C97.6205 81.3704 97.4705 78.8404 96.2805 76.7904C94.7405 74.1304 91.6605 72.6404 88.6105 72.2504C85.9305 71.9104 82.7106 72.1004 80.0606 72.7204C77.8106 73.2704 76.0505 76.1004 75.3205 78.1104Z",
    fill: "#FFA8A8"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0004 77.5004C75.2204 78.4104 74.9803 79.6404 74.7103 80.8104C73.9103 84.2504 72.5903 87.5604 70.8203 90.6204C71.8503 90.6904 72.8804 90.6604 73.9104 90.5504",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8008 90.8404C72.8308 92.8204 73.3307 95.0604 73.2407 97.2904C73.2207 97.6904 73.1907 98.1104 73.3407 98.4904C73.6907 99.3804 74.8408 99.6104 75.7908 99.4904C76.7308 99.3804 77.7007 99.0504 78.6107 99.3204C80.2307 99.8104 80.7407 101.8 80.9807 103.48C81.2607 105.37 81.5307 107.32 81.1107 109.19",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2106 102.53C92.9806 99.7704 91.7406 96.6404 92.8606 93.8404C93.2906 92.7604 94.0407 91.8504 94.6707 90.8804C97.2607 86.9004 97.8606 81.6904 96.2506 77.2304C96.0806 76.7704 95.8906 76.3104 95.5806 75.9304C95.2606 75.5404 94.8306 75.2504 94.4106 74.9704C92.7706 73.8804 91.0606 72.7504 89.1106 72.4504C87.8606 72.2504 86.5806 72.4104 85.3206 72.5604C83.4306 72.7904 81.5306 73.0204 79.6406 73.2604",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9707 75.0704C76.9907 75.7604 77.5107 76.3704 78.1407 76.6704C78.7707 76.9704 79.4808 77.0104 80.1808 76.9904C81.5808 76.9404 82.9708 76.6504 84.2708 76.1304",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7503 77.1804C80.5903 78.1904 80.8803 79.2104 81.2203 80.1704C81.5103 81.0204 81.8504 81.8704 82.4304 82.5504C83.4804 83.8004 85.1403 84.3104 86.7103 84.7604C87.5203 84.9904 88.3803 85.2304 89.2003 85.0304",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M86.361 85.8604C86.981 85.3604 87.851 85.1104 88.611 85.3504C89.371 85.5904 89.971 86.3704 89.881 87.1704C89.761 88.2004 88.701 88.8004 88.051 89.6104C87.721 90.0104 87.4909 90.4804 87.1909 90.9104C86.8909 91.3304 86.491 91.7204 85.991 91.8404C85.491 91.9604 84.8709 91.7304 84.7109 91.2404",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4395 82.8004C76.4095 82.7504 77.3896 83.3504 77.7896 84.2404",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1504 85.3004C74.6804 85.2104 75.2404 85.3404 75.6804 85.6404",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4307 66.7304C83.3807 66.3204 82.0506 67.1604 81.9706 68.2904C81.8906 69.4204 83.0906 70.4404 84.1906 70.1704C84.6806 70.0504 85.1607 69.6504 85.1607 69.1404C85.1607 68.6304 84.4906 68.2104 84.1106 68.5404C84.8106 68.4804 85.4906 68.2904 86.1206 67.9804",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8203 69.1704C73.5003 68.7904 74.2003 68.4104 74.9703 68.3404C75.7403 68.2704 76.6104 68.5904 76.9304 69.3004C77.2204 69.9304 76.9804 70.7104 76.5204 71.2304C76.0504 71.7504 75.4004 72.0504 74.7404 72.2704",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2305 69.1604C74.0505 69.9504 74.6805 70.9404 75.0405 72.0204",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M78.86 67.6504C78.82 67.6104 78.78 67.5704 78.75 67.5304",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6708 70.3604C79.6308 70.3204 79.5908 70.2804 79.5508 70.2404",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4609 71.0704C89.7109 70.0104 89.9509 68.9604 90.2009 67.9004C90.2609 67.6404 90.331 67.3604 90.531 67.1904C90.841 66.9204 91.361 67.0204 91.651 67.3104C92.041 67.7004 92.091 68.3804 91.761 68.8204C91.431 69.2604 90.761 69.4004 90.281 69.1304C91.021 69.9604 91.611 70.9104 92.031 71.9404",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4503 69.0804C94.8603 70.2004 94.2204 71.2904 93.5504 72.3704C93.4204 72.2704 93.2804 72.1804 93.1504 72.0804C93.6604 72.5704 94.2803 72.9604 94.9403 73.2204",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4004 70.5604C94.8104 70.8604 95.2804 71.0904 95.7704 71.2304",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2402 69.2504C95.6102 69.5804 95.9902 69.9204 96.3602 70.2504",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5391 71.1904C97.8791 71.4404 98.229 71.6904 98.569 71.9404C98.479 71.8004 98.249 71.8404 98.149 71.9704C98.049 72.1004 98.0391 72.2804 98.0291 72.4404C97.9891 73.4604 97.9591 74.4804 97.9191 75.5004C97.7891 75.3304 97.6691 75.1604 97.5391 74.9904C97.7691 75.4404 98.129 75.8204 98.579 76.0604",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M100.17 73.1104C100.34 73.3504 100.54 73.5604 100.76 73.7504C100.77 73.4004 100.44 73.1204 100.1 73.0704C99.7601 73.0204 99.4101 73.1404 99.0901 73.2504C98.4101 73.4904 97.7302 73.7304 97.0502 73.9704C96.6702 74.1004 96.1902 74.2104 95.9202 73.9104C96.0302 74.0304 96.1501 74.1604 96.2701 74.2804C96.1501 74.1504 96.0302 74.0204 95.9102 73.8904",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M103.79 77.7904C102.8 78.3304 101.81 78.8604 100.82 79.4004C100.71 79.2804 100.63 79.1404 100.59 78.9804C100.88 79.8404 101.45 80.6104 102.19 81.1404",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M103.65 77.6604C104.11 78.0104 104.45 78.5104 104.61 79.0604",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M102.43 78.7304C102.61 79.1904 102.79 79.6504 102.97 80.1104",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M102.471 83.8204C103.741 83.4704 105.001 83.1204 106.271 82.7704",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M105.66 81.8804C105.66 81.6604 105.66 81.4304 105.67 81.2104C105.73 82.2204 105.99 83.2204 106.42 84.1404",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M103.66 88.7104C104.65 88.7804 105.63 88.8604 106.62 88.9304C106.86 88.9504 107.21 88.8404 107.14 88.6104C107.03 88.5304 106.95 88.4004 106.94 88.2704C106.94 88.6504 106.94 89.0304 106.94 89.4104",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M103.18 90.8204C103.19 91.1704 103.21 91.5204 103.22 91.8804C103.32 91.6604 103.36 91.4204 103.32 91.1804C104.47 91.4404 105.66 91.5004 106.83 91.3504C106.83 91.2204 106.84 91.1004 106.84 90.9704C106.84 91.1504 106.84 91.3404 106.84 91.5204",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M106.46 91.3904C105.62 92.2604 104.61 92.9704 103.51 93.4704C104.7 93.5004 105.88 93.5204 107.07 93.5504",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M106.94 93.0504C107.01 93.2904 106.98 93.5504 106.85 93.7604",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M103.07 94.8004C104.21 95.1104 105.35 95.4204 106.48 95.7304",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M106.071 95.6604C106.331 96.3504 106.011 97.1904 105.401 97.6204C104.801 98.0504 103.981 98.1104 103.271 97.8904C103.101 97.8404 102.931 97.7604 102.831 97.6204C102.731 97.4904 102.711 97.3204 102.701 97.1604C102.641 96.3804 102.721 95.5804 102.961 94.8304",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M101.151 99.4104C101.291 99.4204 101.311 99.6604 101.181 99.6904C101.051 99.7304 100.951 99.5004 101.061 99.4304C100.941 99.4704 100.891 99.6404 100.971 99.7404",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M103.699 101.42C103.709 101.26 103.599 101.1 103.459 101.05C103.379 101.16 103.419 101.34 103.549 101.4",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7196 67.2104C78.5996 67.1504 78.5796 67.4404 78.7096 67.3904C78.7396 67.3204 78.7296 67.2204 78.6596 67.1904C78.5896 67.1604 78.4996 67.2604 78.5496 67.3204C78.5996 67.3804 78.6796 67.2204 78.5996 67.2204",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4408 69.8904C79.3808 70.0504 79.6309 70.2104 79.7609 70.0904C79.7809 69.9604 79.5908 69.8504 79.4808 69.9404C79.4308 69.9904 79.5008 70.1004 79.5708 70.0704C79.6408 70.0404 79.6109 69.9204 79.5409 69.9204",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2095 67.1304C87.2495 67.2604 87.2795 67.3904 87.3195 67.5204C87.4695 67.5204 87.5795 67.3304 87.5095 67.2004C87.3595 67.2804 87.2495 67.4104 87.1895 67.5704C87.2295 67.4804 87.2795 67.3904 87.3195 67.3104",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3107 70.1404C87.2207 70.0704 87.0706 70.1504 87.0806 70.2604C87.1406 70.3804 87.3206 70.4104 87.4206 70.3204C87.5206 70.1504 87.1906 69.9704 87.1006 70.1404",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6504 75.3104C65.2904 75.6104 64.9303 75.9104 64.5703 76.2104C64.7803 76.1504 64.9903 76.0904 65.1903 76.0304C65.2103 76.1604 65.2204 76.3004 65.2404 76.4304C66.4704 76.9004 67.7004 77.3604 68.9304 77.8304C68.3604 76.3704 67.7903 74.9104 67.2203 73.4504C67.0603 73.5104 66.9204 73.5804 66.7804 73.6804C67.0404 73.6504 67.2603 73.4404 67.3203 73.1904",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0093 71.4704C68.8593 71.5704 68.7093 71.6704 68.5493 71.7704C68.4393 71.8404 68.5193 72.0504 68.6493 72.0304C68.7793 72.0104 68.7893 71.7904 68.6693 71.7604C68.5393 71.8504 68.4093 71.9404 68.2793 72.0404C68.7193 72.0304 69.1293 72.3104 69.4193 72.6404C69.7093 72.9704 69.9093 73.3804 70.1593 73.7404C70.4993 74.2404 70.9392 74.6904 71.4392 75.0404C71.4192 74.9304 71.4393 74.8104 71.4993 74.7104C71.2993 74.8904 71.0993 75.0704 70.8993 75.2504C71.1193 75.0804 71.3293 74.9004 71.5493 74.7304",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9199 91.2204C79.4799 90.8404 80.9098 89.9604 81.9598 88.7404",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1309 76.8304C82.2809 79.8604 84.7009 82.6204 87.6709 83.1804",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 76.6904C84.32 79.3804 86.6801 81.5404 89.4301 82.1304",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5391 81.5404C92.6391 82.3404 93.029 83.8104 93.099 85.1704C93.179 86.7304 92.939 88.3004 92.389 89.7604",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3301 81.8704C94.7401 84.1304 94.9101 87.1104 93.7601 89.5104",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4293 81.5304C96.0093 83.1104 96.0692 84.8804 95.5892 86.4904C95.5492 86.6404 95.3993 86.8204 95.2793 86.7204",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6992 74.3404C78.1492 75.2104 78.8193 75.9704 79.6493 76.5104",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2207 74.0004C79.6707 75.0904 80.6508 75.9504 81.7908 76.2604",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0098 73.6404C81.4898 74.7404 82.4898 75.5904 83.6498 75.8804",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0996 73.4104C83.6296 74.2704 84.3997 74.9904 85.2997 75.4504",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2109 72.9404C85.6109 73.5104 86.1209 74.0104 86.7109 74.3904",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3905 94.6204C73.2805 94.7204 73.1105 94.7404 72.9805 94.6604C74.0305 94.4504 75.0805 94.2304 76.1205 94.0204",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7098 101.44C99.4998 101.7 99.2998 101.96 99.0898 102.21C99.2598 102.03 99.5599 102.01 99.7899 102.1C100.02 102.19 100.2 102.38 100.38 102.56C100.75 102.94 101.11 103.31 101.48 103.69C101.64 103.85 101.81 104.02 102.03 104.05C102.25 104.09 102.51 103.91 102.48 103.69C102.29 103.87 102.11 104.05 101.92 104.22",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4795 102.86C98.2095 102.92 97.9695 103.05 97.7695 103.24C97.9695 103.17 98.1695 103.11 98.3695 103.04C98.9195 104.03 99.6095 104.95 100.4 105.76C100.29 105.83 100.189 105.9 100.079 105.98C100.039 106.01 99.9695 105.96 99.9795 105.91C99.9895 105.86 100.069 105.85 100.099 105.89",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9492 104.48C98.0892 104.94 99.2293 105.4 100.369 105.86",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8008 104.59C97.3108 105.66 97.6207 106.82 97.7107 108C97.6307 108.17 97.4107 108.27 97.2307 108.22C97.5307 108.07 97.8307 107.91 98.1307 107.76",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8496 105.99C95.0696 105.82 95.2796 105.65 95.4996 105.49C95.2996 105.54 95.3796 105.84 95.5096 106C96.2196 106.88 97.1096 107.61 98.1096 108.14",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3 106.68C93.42 106.58 93.53 106.48 93.65 106.38C93.45 106.51 93.23 106.62 93 106.69C93.16 106.72 93.32 106.69 93.46 106.62C94.19 107.68 94.91 108.74 95.64 109.8",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1193 108.18C93.7793 108.3 93.4493 108.46 93.2093 108.72C92.9693 108.99 92.8493 109.38 92.9893 109.71C93.1793 110.16 93.7893 110.31 94.2493 110.15C94.7193 109.99 95.0693 109.62 95.3993 109.26",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9693 108.44C90.8893 108.36 90.8093 108.28 90.7293 108.2C90.5893 108.22 90.5793 108.46 90.7193 108.49",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5302 111.27C91.4602 111.12 91.2002 111.15 91.1602 111.31C91.3602 111.48 91.6801 111.1 91.4801 110.93C91.6101 110.96 91.5602 111.21 91.4302 111.19C91.3002 111.17 91.3201 110.93 91.4501 110.93",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0098 108.99C83.2998 108.68 84.5197 108.1 85.5797 107.31C86.4597 106.64 87.2298 105.83 88.1798 105.25C90.0498 104.13 92.4398 104.05 94.1798 102.74",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3197 106.45C73.3597 106.36 73.4097 106.27 73.4497 106.18C73.1297 106.73 72.8097 107.27 72.4897 107.82C72.8397 107.21 73.2998 106.52 74.0098 106.49C74.7798 106.46 75.3398 107.37 75.1698 108.12C74.9998 108.87 74.3097 109.41 73.5797 109.65C73.0197 109.83 72.2798 109.81 72.0098 109.28",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4093 106.24C68.2793 106.35 68.1593 106.45 68.0293 106.56C68.6593 106.54 69.2892 106.9 69.5892 107.45C70.4592 106.66 71.2093 105.73 71.8093 104.71C71.3193 104.67 70.8392 104.48 70.4592 104.15",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3105 105.18C69.7105 105.56 70.0805 105.99 70.4105 106.44",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2691 100.7C65.5291 100.67 64.8691 101.38 64.8891 102.12C64.9191 102.86 65.5891 103.5 66.3291 103.54C67.0691 103.58 67.7791 103.05 68.0091 102.34",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9805 99.4904C64.2205 99.3504 65.4305 98.9704 66.5305 98.3704",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M62.89 99.3804C62.61 99.1504 62.57 98.7104 62.74 98.3904C62.91 98.0704 63.25 97.8704 63.61 97.8004C64.36 97.6604 65.17 98.1204 65.43 98.8304",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2695 98.2204C64.6995 97.4604 65.2096 96.7504 65.7896 96.1004",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8496 91.8904C60.9696 92.5004 61.1196 93.1204 61.4596 93.6404C61.7896 94.1604 62.3396 94.5904 62.9596 94.6304C63.7196 94.6804 64.4596 94.0704 64.5696 93.3104C64.6696 92.5504 64.1196 91.7704 63.3696 91.6104C63.1696 91.5704 62.9397 91.5804 62.7897 91.7104C62.5097 91.9704 62.7097 92.4304 62.9197 92.7504",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4004 89.5004C61.8104 89.6304 63.2404 89.5604 64.6304 89.2804",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7402 87.0504C61.8302 86.7904 62.8902 86.4504 63.9402 86.0604",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 83.4604C62.2095 84.1704 63.3295 84.9904 64.3595 85.9104",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2096 83.2904C61.1496 83.5104 61.3596 83.7504 61.5896 83.7204C61.8096 83.6904 61.9396 83.3804 61.8196 83.2004C61.6896 83.0104 61.3696 83.0204 61.2496 83.2204C61.1796 83.6004 61.2096 83.9904 61.3296 84.3604",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M231.3 61.6504H176.15V116.8H231.3V61.6504Z",
    fill: "#FFC9C9"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M204.08 111.86C216.771 111.86 227.06 101.572 227.06 88.8804C227.06 76.1889 216.771 65.9004 204.08 65.9004C191.388 65.9004 181.1 76.1889 181.1 88.8804C181.1 101.572 191.388 111.86 204.08 111.86Z",
    fill: "#FFA8A8"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M195.02 73.0304C194.41 73.2504 194.23 74.1804 194.71 74.6104C194.62 74.5204 194.53 74.4304 194.44 74.3404",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M194.6 74.9204C194.44 76.1004 195.19 77.3504 196.31 77.7604",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M194.369 75.5104C193.849 76.2204 193.959 77.2404 194.409 77.9904C194.849 78.7404 195.569 79.2904 196.269 79.8304",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M193.789 77.8704C193.909 80.7804 195.189 83.4904 196.009 86.2804C196.369 87.4904 196.609 88.9004 195.889 89.9404C195.629 90.3104 195.239 90.7104 195.389 91.1404C195.749 91.1704 196.099 90.9004 196.169 90.5504",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M196.55 75.7504C196.51 76.2404 196.55 76.7304 196.68 77.2104C196.77 77.5404 197.11 77.9304 197.37 77.7104C197.45 77.6404 197.49 77.5304 197.51 77.4204C197.59 77.1004 197.68 76.7804 197.76 76.4604",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M197.02 74.8104C197.16 74.8204 197.29 74.7804 197.41 74.7104C197.32 74.7404 197.23 74.7804 197.14 74.8104",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M197.719 73.9804C198.039 73.5504 198.609 73.3204 199.139 73.4004",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M195.879 73.6704C196.099 73.4304 196.559 73.4904 196.709 73.7804C196.579 73.6904 196.449 73.6004 196.309 73.5104",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M197.359 75.1704C197.789 75.5604 198.609 75.3304 198.759 74.7604C198.689 74.8904 198.619 75.0204 198.539 75.1604",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M199.561 73.0804C199.821 72.9604 200.131 73.2404 200.141 73.5304C200.161 73.8204 199.99 74.0804 199.83 74.3204",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M198.81 72.9504C199.25 72.4504 199.74 72.0004 200.27 71.6104C199.44 71.8704 198.46 71.3904 198.15 70.5804C197.96 70.0904 197.92 69.4104 197.42 69.2404C197.03 69.1104 196.59 69.4704 196.56 69.8804C196.55 70.0804 196.6 70.3104 196.46 70.4604C196.37 70.5604 196.22 70.5804 196.1 70.6204C195.68 70.7604 195.41 71.1404 195.09 71.4404C194.77 71.7404 194.27 71.9704 193.9 71.7304C194.59 72.0904 195.21 72.5904 195.7 73.1904",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M195.51 73.3304C196.76 72.7904 198.15 72.5904 199.5 72.7504",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M198.79 72.1204C197.81 72.0704 196.83 72.0804 195.85 72.1604",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M197.141 71.2804C197.311 71.1804 197.491 71.0804 197.661 70.9904C197.491 71.0904 197.311 71.1804 197.141 71.2804Z",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M200.819 69.3104C200.639 69.4904 200.439 69.6904 200.419 69.9504C200.399 70.2104 200.679 70.4804 200.899 70.3504",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M202.93 68.7904C203.59 69.7004 203.45 71.1004 202.63 71.8704C204.77 71.1104 206.85 70.1804 208.85 69.1104C207.48 70.6904 205.55 71.7904 203.49 72.1704C204.3 72.5804 205.21 72.7804 206.12 72.7504C206.68 72.7304 207.26 72.6304 207.79 72.8204C208.32 73.0104 208.73 73.6604 208.44 74.1404C207.09 72.7704 204.39 74.1204 202.98 72.8004C202.54 72.9604 202.48 73.6204 202.77 74.0004C203.06 74.3704 203.54 74.5304 204 74.6604C205.15 75.0004 206.31 75.3404 207.46 75.6904C207.32 75.4404 207.17 75.1904 207.03 74.9404C208.12 75.3004 209.18 75.7304 210.21 76.2304C210.21 75.9904 210.46 75.8204 210.7 75.8204C210.94 75.8204 211.16 75.9504 211.36 76.0704C212.43 76.7404 213.43 77.5304 214.33 78.4204C214.81 78.9004 215.3 79.5204 215.19 80.1904C215.08 80.8204 214.44 81.2604 213.8 81.3404C213.16 81.4204 212.52 81.2404 211.91 81.0504C210.77 80.7104 209.63 80.3704 208.48 80.0304",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M202.81 68.8604C201.64 69.7104 201.95 71.5404 201.28 72.8304C201.18 73.0304 201.05 73.2204 201.01 73.4404C200.91 74.0704 201.57 74.5204 202.1 74.8704C202.9 75.3804 203.62 76.0104 204.49 76.3804C205.05 76.6204 205.65 76.7404 206.24 76.8604C208.14 77.2404 210.03 77.6204 211.93 78.0004C212.51 78.1204 213.23 78.3904 213.24 78.9804C213.25 79.3504 212.94 79.6604 212.59 79.7804C212.24 79.9004 211.86 79.8704 211.5 79.8404C210.43 79.7504 209.34 79.6504 208.34 79.2404C207.24 78.7804 206.29 77.9504 205.12 77.7504C204.59 77.6604 204.04 77.7104 203.5 77.7204C202.22 77.7304 200.94 77.4704 199.76 76.9604C199.91 76.6704 200.07 76.3804 200.22 76.0904C199.94 75.8804 199.64 75.6604 199.49 75.3304C199.34 75.0104 199.41 74.5604 199.72 74.4004",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M201.679 80.0704C201.049 80.4904 200.819 81.3104 200.779 82.0604C200.739 82.8104 200.859 83.5804 200.739 84.3204C200.589 85.2204 200.089 86.0304 199.899 86.9204C199.719 87.7404 199.819 88.6004 199.729 89.4404C199.649 90.2804 199.319 91.1704 198.579 91.5704C198.629 91.1704 198.679 90.7804 198.729 90.3804C198.629 90.7204 198.509 91.0804 198.229 91.2904C197.949 91.5004 197.449 91.4504 197.339 91.1204C197.259 90.8804 197.409 90.6104 197.339 90.3704C197.199 90.6304 197.039 90.9104 196.759 91.0104C196.479 91.1104 196.089 90.8904 196.169 90.6004C196.209 90.4504 196.339 90.3604 196.469 90.2604C197.289 89.6404 197.779 88.6604 198.009 87.6504C198.239 86.6404 198.219 85.6004 198.209 84.5704C198.199 83.9804 198.189 83.4004 198.189 82.8104",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M200.92 82.8804C202.45 83.3704 204.11 83.4804 205.69 83.1904C206.52 84.4404 207.66 85.4904 208.98 86.2204C209.64 86.5904 210.42 86.9404 210.67 87.6604C211.13 88.9404 209.58 90.1504 209.64 91.5104C210.1 91.5204 210.56 91.3704 210.92 91.0804C210.63 91.5604 210.58 92.1804 210.8 92.7004C211.17 92.4304 211.46 92.0604 211.63 91.6404C211.7 91.8104 211.78 91.9804 211.85 92.1604C212.12 92.0104 212.22 91.6804 212.3 91.3804C212.72 89.7604 213.15 88.1404 213.57 86.5204C213.6 86.4004 213.63 86.2604 213.58 86.1504C213.45 85.8804 213.06 85.9804 212.76 85.9704C211.95 85.9404 211.68 84.9004 211.48 84.1204C211.03 82.3804 209.77 80.8704 208.15 80.1004",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M205.08 83.4004C205.4 85.0904 206.42 86.6504 207.86 87.6004C208.27 87.8804 208.78 88.2204 208.72 88.7204",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M199.72 76.2104C199.31 77.0504 198.75 77.8004 198.07 78.4404",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M195.86 91.1104C194.45 91.3404 194.13 93.6004 192.72 93.8504C192.24 93.9404 191.761 93.7504 191.271 93.7004C190.781 93.6504 190.191 93.8204 190.061 94.2904C191.551 95.0804 192.761 96.3804 193.431 97.9204C193.781 98.7104 193.99 99.5504 194.19 100.38C194.31 100.88 194.441 101.38 194.561 101.88",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M199.99 88.3804C201.06 87.8604 202.2 87.4604 203.36 87.2104C203.09 87.1504 202.89 86.8804 202.92 86.6104C202.95 86.3404 203.2 86.1104 203.48 86.1204C203.29 85.7604 203.2 85.3404 203.24 84.9404C203.06 84.9404 202.87 84.9404 202.69 84.9404C202.6 85.3104 202.44 85.6704 202.23 85.9904C202.15 85.3904 202.08 84.8004 202 84.2004C202.37 84.4104 202.73 84.6304 203.1 84.8404C203.11 84.3604 203.14 83.8704 203.2 83.3904",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M204.909 83.5104C204.899 84.1304 204.899 84.7504 204.889 85.3704C204.889 85.5004 204.859 85.6704 204.739 85.7104C204.659 85.7304 204.579 85.7004 204.509 85.6604C204.269 85.5404 204.019 85.4204 203.779 85.3004C203.859 85.8904 203.929 86.4904 204.009 87.0804C205.809 87.3304 207.559 87.8804 209.179 88.7104",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M212.049 91.0704C212.769 91.8704 213.489 92.6704 214.209 93.4704C214.279 93.5504 214.359 93.6404 214.459 93.6804C214.559 93.7204 214.669 93.7104 214.779 93.7004C215.399 93.6504 216.019 93.5904 216.629 93.5404C215.669 93.9204 215.099 94.9004 214.689 95.8504C213.779 97.9604 213.329 100.26 213.349 102.55",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M195.26 103.37C197.8 101.79 200.89 101.27 203.87 101.4C206.86 101.53 209.78 102.29 212.65 103.12C212.44 103.14 212.22 103.06 212.07 102.91",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M194.41 101.32C199.82 98.2504 206.74 98.0304 212.34 100.73",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M202.779 88.6804C202.779 89.7004 202.779 90.7204 202.779 91.7404",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M201.73 91.1404C202.63 92.0204 204.11 92.2304 205.22 91.6404C204.6 91.9004 204.15 92.5104 204.08 93.1704C204.42 93.2404 204.76 93.3104 205.1 93.3804C205.1 92.8004 205.53 92.2504 206.09 92.1104C205.85 92.9704 205.77 93.8704 205.84 94.7604C205.36 94.5304 204.891 94.2904 204.411 94.0604C204.111 94.3704 204.141 94.8804 204.291 95.2904C204.581 96.0904 205.301 96.7504 206.141 96.8404C206.981 96.9304 207.88 96.3204 208 95.4904C208.05 95.1404 207.951 94.7504 207.661 94.5504C207.371 94.3504 206.891 94.4404 206.781 94.7704C206.471 94.1404 206.861 93.2704 207.541 93.0804C208.221 92.8904 209.001 93.4404 209.051 94.1504C209.301 93.4504 208.34 92.8904 208.22 92.1604C208.15 91.7804 208.341 91.3804 208.671 91.1804C209.001 90.9804 209.45 91.0104 209.75 91.2504C209.7 91.1804 209.65 91.1104 209.61 91.0304",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M201.819 91.4804C202.509 91.6304 203.019 92.3504 202.949 93.0504C202.539 92.7504 202.089 92.4904 201.609 92.3004C201.609 93.1004 201.619 93.8904 201.619 94.6904C202.059 94.5204 202.499 94.3404 202.939 94.1704C203.029 94.1404 203.119 94.1004 203.209 94.1304C203.349 94.1804 203.389 94.3504 203.399 94.4904C203.429 95.1904 203.059 95.8804 202.489 96.2904C201.919 96.7004 201.179 96.8504 200.489 96.7404C199.939 96.6604 199.319 96.2804 199.359 95.7204",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M199.14 95.1504C199.22 94.4604 200.13 94.0104 200.72 94.3804C200.92 93.8804 200.43 93.3004 199.89 93.2804C199.35 93.2604 198.87 93.6504 198.62 94.1304C198.75 93.5204 198.7 92.8504 198.37 92.3204C198.04 91.7904 197.4 91.4304 196.79 91.5404C196.42 92.7204 197.05 94.1304 198.18 94.6504C197.6 94.5004 197.13 94.0004 196.53 93.9804C195.91 93.9604 195.34 94.5604 195.4 95.1804C195.46 95.8004 196.13 96.2904 196.74 96.1504C196.34 96.0304 196.36 95.3704 196.73 95.1904C197.1 95.0104 197.58 95.2804 197.72 95.6704C197.86 96.0604 197.72 96.5004 197.48 96.8404C196.93 97.6104 195.8 97.9104 194.94 97.5104C194.08 97.1104 193.58 96.0604 193.81 95.1404C193.82 95.0804 193.85 95.0104 193.91 95.0004C193.97 94.9804 194.03 95.0804 193.97 95.1104",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M204.43 89.1504C204.43 89.0004 204.43 88.8504 204.43 88.7004C204.44 89.4704 204.45 90.2304 204.46 91.0004C204.52 90.1704 204.58 89.3304 204.64 88.5004C206.31 88.9504 207.93 89.6004 209.45 90.4304",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M212.189 92.9304C212.709 92.8704 213.23 93.3304 213.24 93.8504",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M202.199 88.7904C201.299 88.8404 200.419 89.1604 199.699 89.6904",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M196.199 91.9804C195.499 92.4004 194.919 93.0104 194.549 93.7404",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M199 97.0204C198.71 97.5804 198.28 98.0704 197.77 98.4404C198.2 98.4504 198.599 98.7704 198.709 99.1904",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M199.029 97.1404C199.319 97.6604 199.809 98.0604 200.379 98.2304C200.189 98.3304 200.039 98.4904 199.959 98.6804",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M203.729 96.4404C203.359 96.9204 202.889 97.3204 202.359 97.6104C202.729 97.8404 203.059 98.1304 203.339 98.4704",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M208.069 98.7904C207.889 98.4704 207.709 98.1604 207.529 97.8404C208.009 97.6404 208.449 97.3404 208.809 96.9604C208.679 97.1904 208.929 97.4504 209.139 97.6104C209.349 97.7704 209.559 98.0804 209.379 98.2704C209.289 98.3604 209.149 98.3804 209.059 98.4704C208.969 98.5504 209.009 98.7704 209.129 98.7304",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M209.641 96.2104C209.891 97.0804 210.871 97.5804 211.781 97.5504C212.691 97.5304 213.531 97.1104 214.321 96.6704",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M209.7 96.1004C209.5 95.6104 209.75 94.9504 210.26 94.8104C210.77 94.6704 211.35 95.2504 211.13 95.7304C211.59 95.3704 211.79 94.6604 211.48 94.1704C211.17 93.6804 210.33 93.6004 210.01 94.1004C210.16 93.5904 210.45 93.1204 210.85 92.7604",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M194.799 102.33C195.279 101.99 195.849 101.77 196.439 101.72",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M198.91 100.79C199.38 100.55 199.91 100.43 200.44 100.43",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M202.779 100.33C203.369 100.28 203.949 100.23 204.539 100.18",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M207.391 100.6C207.821 100.4 208.381 100.52 208.691 100.89",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M210.77 101.3C211.24 101.36 211.699 101.54 212.089 101.81",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M195.77 80.7704C196.31 81.4704 196.679 82.3004 196.859 83.1604",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M198.1 80.2604C199.14 79.8104 200.05 79.0504 200.66 78.1004",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M188.789 87.3704C189.239 87.2404 189.649 86.9704 189.949 86.6104C189.869 87.8504 189.789 89.0904 189.699 90.3304",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M193.149 87.2304C192.539 87.1504 191.929 87.7504 192.009 88.3604C192.089 88.9704 192.819 89.4104 193.389 89.1804",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M192.439 86.9904C191.719 86.9504 191.019 87.4504 190.819 88.1404C190.619 88.8304 190.959 89.6304 191.589 89.9704C192.219 90.3104 193.079 90.1504 193.549 89.6104C193.559 90.6104 192.969 91.6004 192.079 92.0704",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M193.139 86.8004C193.789 86.6404 194.369 87.3104 194.559 87.9504C194.829 88.8404 194.689 89.8504 194.199 90.6404C193.709 91.4304 192.869 92.0104 191.959 92.1704",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M188.561 90.8004C189.131 90.6204 189.75 90.6204 190.33 90.7804",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M215.34 86.4304C214.59 87.2804 213.88 88.1804 213.23 89.1204C213.83 89.3304 214.51 89.3304 215.11 89.1204",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M215.91 86.3304C215.91 87.1604 215.92 87.9804 215.92 88.8104C216.05 88.7804 216.21 88.7504 216.32 88.8304C216.43 88.9104 216.42 89.1404 216.28 89.1404",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M215.01 89.0304C214.91 88.8704 214.87 88.6704 214.89 88.4804C214.89 89.2104 214.9 89.9404 214.9 90.6704C215.24 90.6704 215.59 90.6704 215.93 90.6704C215.91 90.4704 215.96 90.2704 216.06 90.0904",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M219.831 85.7304C218.951 86.0504 218.371 86.9104 218.031 87.7904C217.881 88.1704 217.771 88.5904 217.861 88.9904C217.941 89.3904 218.281 89.7604 218.691 89.7604C219.061 89.7604 219.411 89.4204 219.401 89.0404C219.391 88.6704 219.041 88.3304 218.661 88.3504",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M218.279 87.5904C218.679 87.3304 219.239 87.3504 219.629 87.6204C220.019 87.8904 220.219 88.4104 220.119 88.8804C220.019 89.3504 219.639 89.7104 219.239 89.9704",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M219.6 85.6104C218.47 85.6604 217.531 86.6004 217.161 87.6704C216.941 88.3104 216.9 89.0504 217.24 89.6404C217.58 90.2304 218.38 90.5704 218.98 90.2504",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M222.65 91.4804C222.34 91.4704 222.04 91.8104 222.17 92.0904C222.29 92.3704 222.84 92.3004 222.83 91.9904C222.83 91.9404 222.8 91.8804 222.75 91.8904C222.7 91.9004 222.73 91.9904 222.76 91.9604",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M219.19 79.4904C219.12 79.6404 219.21 79.8404 219.37 79.8804C219.53 79.9204 219.71 79.7804 219.71 79.6204C219.54 79.4204 219.26 79.3404 219.01 79.4104",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M220.539 98.7904C220.479 98.6504 220.359 98.5304 220.219 98.4704C220.069 98.5304 220.019 98.7604 220.139 98.8704C220.339 99.0204 220.669 98.9304 220.759 98.7004C220.849 98.4704 220.669 98.1804 220.419 98.1504",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M187.51 99.1404C187.34 99.0604 187.18 99.3504 187.3 99.5004C187.42 99.6504 187.649 99.6504 187.829 99.5904C187.939 99.3504 187.76 99.0404 187.5 99.0004",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M184.8 92.3304C184.68 92.4404 184.639 92.6304 184.699 92.7804C184.839 92.8104 184.989 92.8104 185.129 92.7804C185.189 92.6204 185.129 92.4204 184.979 92.3404C184.899 92.2904 184.769 92.3004 184.749 92.3904C184.729 92.4804 184.929 92.4504 184.869 92.3904",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M186.56 80.9304C186.35 80.9504 186.25 81.2504 186.4 81.4004C186.54 81.2304 186.25 80.9404 186.08 81.0804C186.04 81.1104 185.99 81.1704 185.94 81.1504C185.89 81.1304 185.97 81.0404 185.97 81.1004",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M221.319 93.5604C221.019 93.3204 220.539 93.5704 220.429 93.9404C220.319 94.3004 220.469 94.7004 220.659 95.0304C220.089 95.0704 219.649 95.7504 219.889 96.2604C220.129 96.7704 221.029 96.7804 221.229 96.2504C221.319 96.5604 221.409 96.8704 221.499 97.1804C221.889 97.4904 222.509 97.4704 222.889 97.1504C223.269 96.8204 223.369 96.2204 223.119 95.7804C223.569 95.9604 224.119 95.4604 223.999 94.9904C223.879 94.5204 223.169 94.3504 222.839 94.7104C223.069 94.0604 222.319 93.3004 221.659 93.5204C221.579 93.5504 221.489 93.6204 221.529 93.7004C221.569 93.7804 221.669 93.6104 221.589 93.6404",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M221.82 95.2704C221.83 95.3804 221.83 95.4904 221.84 95.6004C221.99 95.6604 222.19 95.6104 222.29 95.4804C222.26 95.3104 222.17 95.1504 222.04 95.0504C221.92 95.0804 221.83 95.1904 221.82 95.3104C221.86 95.2204 221.91 95.1304 221.95 95.0404",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M185.84 95.1504C185.62 94.7804 184.97 94.8704 184.78 95.2604C184.59 95.6504 184.79 96.1504 185.15 96.4004C184.71 96.3304 184.39 96.9704 184.66 97.3304C184.92 97.6904 185.52 97.6804 185.85 97.3904C185.8 97.8804 186.32 98.3304 186.8 98.2204C187.28 98.1104 187.54 97.4704 187.28 97.0604C187.7 97.3704 188.41 97.0304 188.44 96.5004C188.47 95.9804 187.8 95.5704 187.34 95.8304C187.66 95.4404 187.48 94.7604 187.01 94.5804C186.54 94.4004 185.95 94.7704 185.92 95.2704",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M186.39 96.4304C186.41 96.3704 186.33 96.3204 186.28 96.3504C186.23 96.3804 186.27 96.4804 186.33 96.4804C186.43 96.4304 186.37 96.2304 186.25 96.2504C186.07 96.4404 186.46 96.7704 186.62 96.5704C186.72 96.3404 186.33 96.1204 186.18 96.3104",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M204.901 69.3004C204.681 69.2004 204.44 69.5604 204.62 69.7304C204.78 69.8804 205.07 69.6204 204.97 69.4304C204.87 69.2404 204.551 69.2504 204.431 69.4304C204.311 69.6104 204.371 69.8704 204.531 70.0204",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M195.24 103.39C195.66 103.96 196.34 104.25 197 104.49C200.47 105.75 204.28 106.06 207.92 105.4C210 105.02 212.1 104.27 213.55 102.74",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M195.859 98.9104C196.019 98.6104 196.549 98.6504 196.669 98.9704C196.559 98.8704 196.439 98.7704 196.329 98.6704",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M200.9 97.9704C201.27 97.8104 201.7 97.8004 202.07 97.9604",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M204.281 95.9304C204.011 96.1504 204.02 96.6004 204.21 96.8904C204.4 97.1904 204.721 97.3704 205.021 97.5504C204.601 97.7404 204.36 98.2504 204.48 98.6904",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M205.839 98.0904C206.059 98.0904 206.279 98.0904 206.499 98.0904C206.239 98.0904 205.979 98.0904 205.719 98.0904",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M211.1 99.2404C211.33 98.9204 211.91 99.0204 212.03 99.3904",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M198.91 103.46C199.22 103.55 199.53 103.64 199.84 103.74",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M201.26 102.67C201.71 102.69 202.15 102.81 202.55 103.02",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M202.43 104.66C202.7 104.62 202.98 104.58 203.25 104.54",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M204.549 102.67C204.819 102.67 205.099 102.67 205.369 102.67",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M205.84 104.31C206.19 104.37 206.56 104.35 206.91 104.24",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M207.6 103.38C207.78 103.38 207.96 103.38 208.14 103.38C207.96 103.38 207.78 103.38 207.6 103.38Z",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M209.98 103.75C210.11 103.51 210.461 103.43 210.671 103.59",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M183.6 85.1504C183.77 84.2204 184.45 83.3904 185.34 83.0504C185.87 82.8404 186.53 82.8304 186.94 83.2204C187.25 83.5204 187.35 84.0004 187.28 84.4204C187.21 84.8404 187 85.2404 186.78 85.6104",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M184.1 84.9804C185.12 85.2004 186.11 85.5804 187.02 86.1104",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M185.99 79.2904C187.01 79.4804 187.96 80.0504 188.61 80.8604",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M186.32 79.1704C186.4 78.3204 187.37 77.6704 188.19 77.9204C188.71 78.0804 189.11 78.5404 189.22 79.0704C189.33 79.6004 189.15 80.1704 188.78 80.5604",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M188.23 75.9804C188.3 75.7604 188.631 75.9004 188.791 76.0604C189.451 76.7504 190.121 77.4304 190.781 78.1204C191.021 77.8404 191.26 77.5604 191.5 77.2704",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M190.569 76.1204C190.169 76.4304 189.769 76.7304 189.379 77.0404",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M189.739 74.5904C189.229 74.9004 188.719 75.2104 188.209 75.5304",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M191.13 73.5104C191.03 73.6504 190.859 73.7404 190.689 73.7404C191.089 73.2004 191.609 72.7604 192.199 72.4604",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M190.98 73.4304C191.63 74.2004 192.271 74.9604 192.921 75.7304",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M192.66 76.0904C192.9 75.8604 193.14 75.6304 193.38 75.4004",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M192.08 74.3204C192.35 74.1604 192.63 74.0004 192.9 73.8504",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M183.31 86.7004C183.18 87.0104 183.13 87.3604 183.17 87.6904C183.09 87.5004 183.24 87.2704 183.43 87.2004C183.62 87.1204 183.84 87.1504 184.04 87.1804C184.76 87.2904 185.48 87.4004 186.21 87.5104C186.19 87.3904 186.17 87.2704 186.15 87.1504C186.07 87.4604 186.05 87.7804 186.09 88.0904",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M183.109 89.5104C183.229 90.1104 183.289 90.7304 183.269 91.3504C183.279 91.0504 183.279 90.7504 183.289 90.4604C184.189 90.4604 185.079 90.4504 185.979 90.4504",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M184.799 89.1504C184.799 89.5404 184.799 89.9304 184.799 90.3304",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M211.51 71.3804C211.56 71.4104 211.57 71.2804 211.51 71.2804C211.45 71.2804 211.41 71.3404 211.39 71.4004C211.12 72.0504 210.84 72.7004 210.57 73.3504C210.43 73.2804 210.27 73.2504 210.12 73.2904C210.29 73.2704 210.46 73.3104 210.61 73.3904C210.44 73.3604 210.26 73.3204 210.09 73.2904",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M211.48 70.5904C211.72 70.7504 211.95 70.9004 212.19 71.0604",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M212.09 74.5904C212.56 73.9204 213.03 73.2604 213.5 72.5904C213.63 72.4104 213.77 72.2104 213.78 71.9804C213.79 71.7604 213.63 71.5004 213.41 71.5104C213.62 71.7404 213.85 71.9504 214.1 72.1504C214.04 73.2504 214.12 74.3604 214.34 75.4304C214.89 74.6204 215.55 73.8804 216.3 73.2404C216.11 73.1804 215.93 73.1204 215.74 73.0604C215.83 73.2604 215.93 73.4604 216.02 73.6604C215.92 73.4504 215.83 73.2504 215.73 73.0404",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M215.6 77.1604C216.44 76.4404 217.22 75.6604 217.95 74.8304C217.82 74.7704 217.69 74.7104 217.56 74.6504C218.17 75.0704 218.79 75.5804 218.96 76.3004C219.15 77.1104 218.59 78.0304 217.78 78.2304C216.97 78.4304 216.04 77.9004 215.82 77.0904",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M218.75 81.0504C218.88 81.2604 219 81.4804 219.13 81.6904C219.02 81.6704 218.99 81.5204 219.04 81.4304C219.09 81.3404 219.2 81.2804 219.3 81.2404C220.17 80.8404 221.05 80.4404 221.92 80.0504C221.86 79.9204 221.74 79.8204 221.61 79.7704C221.71 80.0804 221.82 80.3904 221.92 80.7004",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M219.629 83.3104C220.609 83.0704 221.569 82.7404 222.489 82.3204C221.799 82.9504 221.189 83.6704 220.679 84.4504C221.619 84.8304 222.609 85.0804 223.619 85.1704C222.749 85.7104 221.879 86.2504 220.999 86.8004",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M220.73 87.9004C221.44 88.4304 222.43 88.1304 223.32 88.2004C223.42 88.2104 223.52 88.2204 223.61 88.2704C223.72 88.3304 223.81 88.4404 223.86 88.5604C224.1 89.0204 224.011 89.6304 223.651 90.0004C223.291 90.3704 222.69 90.4904 222.22 90.2704C221.98 89.8604 221.9 89.3604 221.99 88.9004",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M190.439 100.55C189.849 100.41 189.209 100.57 188.759 100.97C188.309 101.37 188.069 102 188.139 102.59C188.159 102.79 188.219 102.99 188.339 103.16C188.579 103.52 189.039 103.68 189.469 103.63C189.899 103.58 190.279 103.35 190.589 103.05C191.239 102.42 191.539 101.28 190.899 100.64C190.829 100.58 190.739 100.51 190.659 100.55C190.579 100.6 190.719 100.74 190.739 100.65",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M190.32 104.79C190.41 105.05 190.59 105.28 190.83 105.44C191.29 104.84 191.75 104.24 192.21 103.64C192.36 103.44 192.52 103.23 192.56 102.98C192.6 102.73 192.45 102.44 192.2 102.41C192.43 102.59 192.67 102.77 192.9 102.95C192.94 102.84 192.76 102.77 192.67 102.84C192.58 102.92 192.58 103.05 192.59 103.17C192.65 104.52 192.72 105.87 192.78 107.22C192.65 107.03 192.52 106.85 192.38 106.66C192.53 106.76 192.68 106.86 192.83 106.96C193.65 106.18 194.34 105.27 194.88 104.27C194.68 104.2 194.47 104.12 194.27 104.05C194.37 104.41 194.79 104.65 195.15 104.54",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M196.05 104.89C195.54 105.92 194.93 106.91 194.25 107.84C194.82 108.12 195.38 108.41 195.95 108.69",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M195.35 106.35C195.82 106.67 196.35 106.89 196.91 107",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M196.199 105.02C196.679 105.16 197.129 105.39 197.509 105.71",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M197.97 107.39C197.78 107.41 197.66 107.65 197.75 107.82C197.92 107.95 198.19 107.64 198.03 107.49C197.91 107.5 197.8 107.51 197.68 107.51C197.81 107.54 197.94 107.57 198.08 107.6",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M200.739 106.55C200.429 106.21 199.859 106.13 199.469 106.39C199.079 106.65 198.919 107.2 199.099 107.62C199.219 107.9 199.47 108.12 199.56 108.41C199.66 108.72 199.55 109.08 199.3 109.28C199.05 109.48 198.669 109.51 198.399 109.35C198.339 109.31 198.259 109.27 198.199 109.31C198.139 109.35 198.269 109.45 198.269 109.38",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M201.719 106.55C201.799 107.64 201.699 108.74 201.449 109.8C201.499 109.62 201.549 109.44 201.599 109.26",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M201.719 108.21C202.559 108.72 203.639 108.83 204.559 108.5C204.269 108.02 204.169 107.44 204.279 106.89C204.279 108.02 204.169 109.16 203.939 110.27C203.979 110.16 204.029 110.06 204.069 109.95",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M205.911 106.43C205.961 107.4 205.971 108.38 205.961 109.36C205.961 109.64 205.911 109.98 205.641 110.07C206.031 110.15 206.451 110.07 206.781 109.86",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M205.95 106.65C205.79 106.72 205.6 106.68 205.48 106.56",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M207.129 106.2C207.409 106.2 207.689 106.2 207.969 106.2C207.789 106.13 207.559 106.24 207.489 106.42C207.659 107.36 207.829 108.31 208.009 109.25C208.619 109.11 209.229 108.97 209.849 108.83",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M209.609 105.88C209.999 105.74 210.379 105.58 210.759 105.4C210.509 105.44 210.269 105.55 210.079 105.72C210.279 106.53 210.559 107.32 210.919 108.07C210.969 108.17 211.029 108.29 211.139 108.33C211.229 108.37 211.339 108.34 211.439 108.31C211.859 108.18 212.269 108.03 212.669 107.86",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M212.78 104.32C212.6 104.44 212.42 104.56 212.24 104.68C212.38 104.56 212.56 104.47 212.74 104.42C212.62 104.5 212.51 104.57 212.39 104.65C212.61 105.72 213.05 106.74 213.68 107.63",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M213.561 103.9C213.831 103.74 214.11 103.58 214.38 103.41C214.19 103.36 214.01 103.57 214.01 103.77C214.02 103.97 214.14 104.14 214.26 104.3C214.77 104.97 215.271 105.65 215.781 106.32C215.601 106.36 215.43 106.41 215.25 106.45",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M214.289 103.68C215.419 103.88 216.529 104.23 217.559 104.74C216.789 104.04 216.219 103.13 215.909 102.14C215.699 102.28 215.489 102.43 215.289 102.57C215.519 102.42 215.739 102.27 215.969 102.11",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M218.189 99.5204C217.719 99.6704 217.429 100.13 217.239 100.58C217.039 101.06 216.909 101.66 217.239 102.06C217.509 102.39 217.979 102.45 218.399 102.46C218.829 102.46 219.289 102.42 219.639 102.17C219.999 101.93 220.219 101.43 220.029 101.05C219.839 100.66 219.169 100.59 218.989 100.98C219.139 100.74 219.329 100.52 219.559 100.33C219.169 100.5 218.799 100.72 218.449 100.97C218.669 100.83 218.899 100.69 219.119 100.55",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M170.5 0.849609H115.35V55.9996H170.5V0.849609Z",
    fill: "#FFC9C9"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M143.799 51.9296C156.684 51.9296 167.129 41.4844 167.129 28.5996C167.129 15.7148 156.684 5.26959 143.799 5.26959C130.914 5.26959 120.469 15.7148 120.469 28.5996C120.469 41.4844 130.914 51.9296 143.799 51.9296Z",
    fill: "#FFA8A8"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M143.8 49.4596C155.32 49.4596 164.66 40.1202 164.66 28.5996C164.66 17.0789 155.32 7.73956 143.8 7.73956C132.279 7.73956 122.939 17.0789 122.939 28.5996C122.939 40.1202 132.279 49.4596 143.8 49.4596Z",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.25 0.25"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M148.969 21.0496C149.869 22.1496 151.499 22.5896 152.829 22.0896",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M149.189 20.9096C150.149 21.2896 151.189 21.4696 152.219 21.4496",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M150.418 21.2996C151.048 20.5596 152.128 20.4496 153.098 20.3996C153.748 20.3596 154.548 20.3996 154.868 20.9796C155.148 21.4796 154.858 22.1296 154.438 22.5196C154.018 22.9096 153.478 23.1696 153.068 23.5596C152.648 23.9596 152.378 24.6096 152.658 25.1096",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M153.429 22.4596C152.589 22.8896 151.739 23.3296 151.019 23.9296C150.299 24.5296 149.689 25.3296 149.489 26.2496C149.329 26.9796 149.419 27.7396 149.609 28.4596C149.929 29.6796 150.719 30.9696 151.979 31.1196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M152.799 25.1896C153.749 24.7396 154.939 25.1596 155.669 25.9296C156.399 26.6896 156.759 27.7296 157.069 28.7396C157.489 30.1296 157.839 31.5396 158.119 32.9696",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M148.908 29.4496C149.318 30.1096 149.648 30.8096 149.898 31.5396C150.338 31.2696 150.878 31.1396 151.398 31.1996",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M149.289 31.0796C149.429 31.4096 149.569 31.7296 149.699 32.0596C149.729 32.1396 149.769 32.2096 149.829 32.2696C149.909 32.3396 150.029 32.3496 150.139 32.3596C151.369 32.4596 152.799 32.4796 153.609 31.5496",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M153.549 31.8296C153.879 32.5296 153.619 33.4496 152.969 33.8696C152.579 34.1196 152.089 34.1996 151.719 34.4696",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M153.809 34.8096C154.279 33.9596 154.549 33.0096 154.599 32.0396C155.579 33.0496 157.109 33.4796 158.469 33.1396",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M157.269 22.6396C157.109 22.6096 156.949 22.5796 156.789 22.5596C157.119 22.5196 156.899 21.8996 157.179 21.7196C157.269 21.6596 157.379 21.6696 157.479 21.6896C157.959 21.7396 158.439 21.7996 158.919 21.8496C158.169 22.6596 157.719 23.7496 157.689 24.8596",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M161.03 21.0896C160.57 21.0296 160.07 21.2596 159.89 21.6796C159.71 22.1096 159.95 22.6796 160.4 22.7796C159.79 22.7796 159.28 23.4296 159.37 24.0296C159.46 24.6396 160.08 25.0896 160.69 25.0696C161.3 25.0496 161.86 24.5896 162.07 24.0096",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M156.869 25.8096C156.879 25.8696 156.799 25.9196 156.749 25.8896C156.699 25.8596 156.719 25.7596 156.779 25.7496C157.189 25.9296 157.659 25.9696 158.099 25.8596C158.169 26.5096 158.279 27.1596 158.419 27.7996",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M159.389 25.4396C159.389 26.1096 159.389 26.7696 159.389 27.4396",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M161.849 25.6596C161.579 25.7096 161.299 25.7696 161.029 25.8196C160.899 26.5396 160.859 27.2696 160.909 27.9896C160.559 28.0496 160.219 28.0996 159.869 28.1596C159.859 28.4596 159.849 28.7696 159.829 29.0696C159.599 29.0796 159.369 29.0796 159.139 29.0896",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M160.668 21.2396C161.188 21.5096 161.268 22.3496 160.808 22.7196C161.148 22.4696 161.688 22.5596 161.928 22.8996C162.168 23.2396 162.078 23.7796 161.728 24.0196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M144.438 11.3496C144.728 11.8096 144.788 12.3996 144.598 12.9096C144.508 13.1396 144.378 13.3496 144.318 13.5896C144.108 14.4396 144.918 15.3096 144.668 16.1496",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M137.289 14.1596C139.079 13.8896 140.849 13.4896 142.579 12.9696",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M144.699 11.5996C145.769 11.3396 146.829 11.0096 147.869 10.6296",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M138.469 9.7796C139.569 10.2896 140.659 10.7996 141.759 11.3196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M145.039 12.9996C146.219 13.2896 147.379 13.6796 148.499 14.1696",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M142.449 11.5496C142.119 11.6996 141.919 12.0696 141.969 12.4296C142.019 12.7796 142.339 13.0796 142.689 13.1196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M142.949 11.6996C142.739 11.9296 142.789 12.3396 143.049 12.5096",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M131.96 34.6796C131.78 34.8196 131.6 34.9496 131.42 35.0896C131.37 35.3296 131.66 35.4796 131.89 35.5396C134.32 36.1196 136.83 35.2296 139.22 34.4896C139.62 34.3596 140.08 34.2496 140.46 34.4396C140.74 34.5796 140.91 34.8596 141.04 35.1396C141.62 36.3596 141.6 37.8596 140.99 39.0596C140.76 39.5196 140.44 40.0496 140.67 40.5096C140.81 40.7896 141.12 40.9396 141.41 41.0496C142.34 41.4096 143.33 41.6096 144.33 41.6496C145.44 41.6896 146.87 41.1896 146.85 40.0796C146.84 39.4296 146.31 38.9296 146.09 38.3196C145.81 37.5396 146.07 36.6696 146.33 35.8796C146.43 35.5796 146.54 35.2696 146.78 35.0696C147.13 34.7896 147.64 34.8496 148.09 34.9296C149.81 35.2496 151.5 35.7096 153.15 36.3196C153.65 36.4996 154.17 36.7096 154.7 36.6696C155.23 36.6296 155.79 36.2696 155.85 35.7396C155.91 35.2096 155.25 34.6896 154.82 35.0096",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M131.359 35.3296C131.449 35.9696 131.619 36.5996 131.869 37.1996C131.949 37.3796 132.029 37.5596 132.169 37.6996C132.509 38.0596 133.069 38.0796 133.559 38.0396C135.249 37.9096 136.869 37.3496 138.509 36.9596C139.239 36.7896 140.129 36.6896 140.629 37.2396C140.989 37.6296 141.019 38.2296 140.849 38.7196C140.679 39.2096 140.339 39.6296 139.999 40.0296",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M141.158 38.8296C141.898 39.3496 142.858 39.4696 143.758 39.3596C144.658 39.2496 145.508 38.9196 146.358 38.5896",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M146.489 39.1496C146.299 38.8696 146.109 38.5696 146.079 38.2396C146.019 37.4396 146.929 36.8996 147.719 36.7896C149.019 36.6196 150.319 37.0196 151.579 37.4096C152.049 37.5596 152.519 37.7096 152.999 37.8596C153.299 37.9596 153.609 38.0496 153.929 38.0296C154.759 37.9796 155.329 37.1996 155.709 36.4596",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M138.039 21.7896C138.049 24.0496 138.049 26.3096 138.059 28.5796C138.059 29.3996 138.069 30.2396 138.309 31.0296C138.649 32.1296 139.419 33.0296 140.179 33.8896C141.009 34.8296 141.869 35.7796 142.989 36.3496C143.249 36.4796 143.529 36.5896 143.809 36.5596C144.059 36.5296 144.279 36.3896 144.489 36.2496C146.099 35.1996 147.789 34.0596 148.549 32.2996C148.979 31.2996 149.079 30.1896 149.149 29.0996C149.309 26.5796 149.389 24.0596 149.369 21.5396",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M137.869 21.5896C139.159 21.6696 140.459 21.7396 141.749 21.8196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M144.809 21.8396C146.259 21.7996 147.709 21.7596 149.159 21.7196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M133.52 36.1396C133.6 36.4896 133.68 36.8496 133.76 37.1996",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M135.408 36.3796C135.338 36.6296 135.428 36.9196 135.628 37.0896",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M137.049 36.1396C137.129 36.3796 137.199 36.6096 137.279 36.8496",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M138.338 36.1396C138.378 36.2996 138.418 36.4496 138.458 36.6096",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M147.85 35.9096C147.91 36.0296 147.97 36.1496 148.03 36.2596C147.98 36.1396 147.92 36.0196 147.87 35.8996",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M149.158 36.0196C149.198 36.0596 149.238 36.0996 149.278 36.1396",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M150.689 36.2596C150.769 36.3796 150.85 36.4996 150.93 36.6096",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M142.449 40.4896C142.439 40.5996 142.479 40.7096 142.559 40.7896C142.529 40.6896 142.489 40.5896 142.449 40.4896Z",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M143.979 40.1396C144.049 40.3796 144.118 40.6196 144.188 40.8496",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M145.27 40.6196C145.35 40.6596 145.43 40.6996 145.5 40.7396",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M125.148 22.2396C125.588 21.9096 126.028 21.5796 126.468 21.2496C126.468 22.4096 126.458 23.5696 126.458 24.7396",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M129.749 21.8196C129.359 21.7196 128.969 21.6596 128.569 21.6596C128.249 21.6496 127.909 21.6896 127.649 21.8796C127.269 22.1496 127.179 22.7196 127.379 23.1396C127.589 23.5596 128.039 23.8196 128.509 23.8696C128.979 23.9196 129.499 23.7496 129.769 23.3596C130.039 22.9696 130.009 22.3696 129.629 22.0696C130.039 22.9296 129.889 24.0296 129.269 24.7596C129.059 24.9996 128.799 25.2096 128.489 25.2696C128.179 25.3296 127.819 25.2296 127.649 24.9596",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M125.049 25.9396C125.469 26.0296 125.909 26.0696 126.339 26.0496C126.309 26.6296 126.349 27.2096 126.479 27.7796C126.779 27.6696 127.099 27.6396 127.409 27.6896",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M127.648 26.0296C127.648 26.6396 127.648 27.2596 127.648 27.8696C127.688 27.7596 127.718 27.6596 127.758 27.5496",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M127.409 26.0296C127.299 25.8396 127.459 25.5696 127.679 25.5696C127.899 25.5696 128.059 25.8496 127.949 26.0296C127.839 26.2096 127.519 26.2096 127.409 26.0296Z",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M128.589 26.1596C128.999 26.0296 129.419 25.9396 129.839 25.8996C129.589 25.9496 129.339 26.0096 129.089 26.0596C128.979 26.8696 128.88 27.6896 128.77 28.4996C128.36 28.3796 127.94 28.3196 127.52 28.2996",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M127.758 28.2596C127.758 28.5696 127.758 28.8896 127.758 29.1996",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M133.078 21.1896C132.238 21.4296 131.698 22.3096 131.598 23.1796C131.498 24.0496 131.748 24.9196 132.018 25.7496C132.318 26.6696 132.668 27.5896 133.268 28.3496C133.778 28.9996 134.448 29.5096 134.958 30.1596C135.468 30.8096 135.798 31.6996 135.488 32.4596C135.078 33.4596 133.518 33.6996 132.828 32.8696C132.778 32.8096 132.728 32.7396 132.718 32.6596C132.708 32.5496 132.778 32.4396 132.848 32.3496C133.838 30.9596 133.848 28.9396 132.878 27.5496C132.138 28.3996 131.708 29.4996 131.678 30.6296C130.798 29.9596 129.738 29.5196 128.648 29.3896C129.178 31.1296 130.778 32.4896 132.578 32.7296",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M132.458 32.9596C132.308 33.5396 132.538 34.1696 132.968 34.5896C133.398 35.0096 133.988 35.2196 134.588 35.2696C135.938 35.3796 137.328 34.6396 137.988 33.4596C138.748 32.0996 138.538 30.3996 137.978 28.9496C137.418 27.4996 136.548 26.1896 135.978 24.7496C135.908 24.5696 135.838 24.3696 135.908 24.1896C135.998 23.9396 136.288 23.8396 136.538 23.7296C137.208 23.4296 137.738 22.8296 137.948 22.1196C138.028 21.8696 137.968 21.4796 137.698 21.4896C137.518 21.4996 137.418 21.6996 137.338 21.8696C136.888 22.8196 135.748 23.3996 134.708 23.1996",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M134.469 22.7696C135.369 22.7396 136.209 22.0496 136.409 21.1696C136.479 20.8496 136.559 20.4196 136.889 20.3896C137.229 20.8096 137.289 21.4296 137.039 21.9096",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M135.408 21.0996C135.288 21.0896 135.168 21.1396 135.088 21.2396C135.068 21.4696 135.188 21.7296 135.408 21.7796C135.628 21.8296 135.868 21.5396 135.718 21.3596",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M132.818 21.2196C133.528 20.7196 134.428 20.5096 135.278 20.6296",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M130.588 23.2196C130.938 23.1596 131.308 23.1896 131.648 23.3096",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M131.049 24.9196C131.249 24.9396 131.449 24.9596 131.639 24.9796",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M131.168 26.7296C131.438 26.6896 131.718 26.6396 131.988 26.5996",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M132.109 28.1496C132.289 28.0696 132.459 27.9996 132.639 27.9196C132.459 27.9896 132.289 28.0696 132.109 28.1496Z",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M135.738 25.3496C135.978 26.6296 135.868 27.9696 135.418 29.1996C136.148 29.5396 137.048 29.4796 137.738 29.0596",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M136.219 27.3196C136.299 27.8296 136.389 28.3396 136.469 28.8496",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M142.599 29.4296C143.119 30.5096 142.949 31.8896 142.189 32.8196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M144.369 29.2096C143.949 30.3796 143.969 31.6996 144.429 32.8596",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M145.738 28.5996C145.968 28.3196 146.198 28.0496 146.438 27.7696",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M143.988 24.8496C144.198 24.3496 144.648 23.9596 145.168 23.7996",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M147.168 27.0996C147.448 26.8196 147.818 26.6396 148.218 26.5896",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M143.279 25.7896C143.479 25.7096 143.669 25.6296 143.869 25.5496",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M141.049 26.2696C141.189 26.1096 141.369 25.9896 141.579 25.9196C141.439 26.0896 141.249 26.2096 141.049 26.2696Z",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M144.248 28.2796C144.298 28.1096 144.358 27.9296 144.488 27.8096C144.618 27.6896 144.848 27.6496 144.968 27.7796",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M145.998 30.6196C146.218 30.3896 146.698 30.6396 146.638 30.9496",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M144.93 34.0396C145.22 34.0796 145.36 34.5096 145.15 34.7196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M138.969 16.0296C138.749 15.6796 139.079 15.1896 139.489 15.0996C139.899 15.0096 140.309 15.1896 140.689 15.3596",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M146.019 17.8196C146.229 17.4396 146.769 17.3996 147.199 17.4596C147.629 17.5196 148.109 17.6496 148.489 17.4196C148.169 16.9896 147.929 16.5096 147.789 15.9896C147.399 16.0996 146.989 16.2096 146.589 16.1596C146.189 16.0996 145.779 15.8296 145.709 15.4296C146.249 15.4596 146.779 15.5696 147.279 15.7596C146.669 15.5596 146.539 14.5796 147.069 14.2196C147.359 14.6096 147.599 15.0496 147.759 15.5096C147.719 15.3196 147.679 15.1196 147.729 14.9396C147.779 14.7496 147.959 14.5896 148.149 14.6196C148.239 14.6396 148.319 14.6896 148.389 14.7596C148.799 15.1696 148.709 15.9596 148.219 16.2596",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M148.568 17.4396C149.578 16.8496 150.748 16.3696 151.898 16.5796C153.048 16.7896 154.088 17.9496 153.778 19.0796C153.518 19.1896 153.198 18.9096 153.268 18.6396C153.028 18.7696 152.878 19.0096 152.678 19.1896C152.478 19.3696 152.168 19.4896 151.938 19.3396C151.578 19.0996 151.828 18.5396 152.098 18.2096C151.858 18.5596 151.438 18.9596 151.078 18.7396C150.978 18.6796 150.908 18.5696 150.818 18.4896C150.488 18.1796 149.968 18.2296 149.528 18.3496C149.098 18.4796 148.648 18.6696 148.208 18.5896C148.168 18.8996 148.118 19.2096 148.078 19.5296C148.718 18.8696 149.958 18.9896 150.478 19.7396C149.968 20.1396 149.408 20.4796 148.808 20.7396",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M135.428 16.1596C135.328 16.2996 135.278 16.4796 135.138 16.5696C134.958 16.6796 134.738 16.6196 134.528 16.5796C133.348 16.3496 132.068 17.2196 131.838 18.4096C132.458 18.3596 133.078 18.1396 133.578 17.7696C133.518 18.0596 133.288 18.2796 133.148 18.5396C133.008 18.7996 132.998 19.1996 133.258 19.3296C133.518 19.4496 133.798 19.2196 133.998 19.0096C133.958 19.3796 134.048 19.8996 134.418 19.8896C134.648 19.8796 134.788 19.6396 134.878 19.4296C135.008 19.1096 135.118 18.7796 135.198 18.4496C135.008 18.6696 135.278 19.0596 135.568 19.0296C135.858 18.9996 136.068 18.6996 136.088 18.4096C136.108 18.1496 135.998 17.8396 135.918 17.5996C140.818 17.7996 136.268 14.9596 135.428 16.1596Z",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M139.75 18.6696C139.14 18.5396 138.48 18.9496 138.28 19.5396C138.08 20.1296 138.32 20.8196 138.81 21.2096C139.3 21.5896 140 21.6696 140.58 21.4496",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M137.048 18.9796C136.888 19.0296 136.728 19.0796 136.568 19.1196C136.608 19.2496 136.698 19.3696 136.818 19.4396",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M140.578 16.8596C140.298 16.9796 140.039 17.1396 139.809 17.3496C140.269 17.8096 140.809 18.2096 141.399 18.4996",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M140.6 15.9996C142.02 16.9096 143.96 16.9196 145.39 16.0196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M140.828 17.6496C141.798 18.1996 143.058 18.1796 144.008 17.5996",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M142.808 13.6696C142.678 14.4496 142.688 15.2596 142.848 16.0296",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M142.109 18.7396C142.109 19.4096 142.109 20.0696 142.109 20.7396",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M145.17 19.9196C145.09 20.3696 145.22 20.8596 145.52 21.2096",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M141.148 21.3296C141.408 21.9496 142.128 22.2696 142.798 22.2596C143.468 22.2496 144.098 21.9696 144.698 21.6696",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M146.438 23.1996C146.248 23.4696 146.378 23.9096 146.688 24.0296",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M139.279 24.0296C139.319 24.2996 139.359 24.5796 139.399 24.8496",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M125.309 35.4696C126.599 35.0196 127.889 34.5796 129.179 34.1296C129.479 34.5496 129.779 34.9896 129.849 35.4996C129.919 36.0096 129.669 36.5996 129.179 36.7496C128.479 36.9596 127.859 36.1896 127.749 35.4696C127.789 35.8896 127.829 36.3096 127.869 36.7196C127.899 37.0496 127.899 37.4696 127.599 37.6296C127.259 37.8196 126.869 37.5096 126.639 37.1996C126.269 36.6996 125.988 36.1296 125.828 35.5196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M127.77 40.4996C128.95 40.1296 130.109 39.6796 131.229 39.1596C131.399 39.0796 131.58 38.9796 131.62 38.7996C131.66 38.6196 131.4 38.4296 131.29 38.5796C131.55 38.7396 131.8 38.9296 132.03 39.1396C132.1 39.2096 132.18 39.2896 132.18 39.3896C132.18 39.4696 132.139 39.5396 132.099 39.6096C131.459 40.6896 130.829 41.7596 130.189 42.8396C130.099 42.7596 130.08 42.6196 130.14 42.5196C130.33 42.6696 130.509 42.8196 130.699 42.9796",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M129.629 40.0296C130.099 40.5396 130.539 41.0896 130.939 41.6596",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M134.02 40.4596C134.51 40.8196 134.96 41.2296 135.35 41.6896C135.22 41.6196 135.09 41.5396 134.97 41.4696C134.35 42.4796 133.72 43.4996 133.1 44.5096C133.07 44.5696 133.03 44.6396 133.07 44.6896C133.11 44.7396 133.22 44.6696 133.17 44.6396",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M134.709 41.2996C135.059 41.7696 135.82 41.6096 136.28 41.9796C136.63 42.2596 136.69 42.8096 136.49 43.2196C136.29 43.6396 135.84 43.9296 135.37 43.9596C134.9 43.9796 134.429 43.7296 134.189 43.3396",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M134.338 43.3396C135.428 43.5296 136.118 44.9096 135.628 45.8996",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M138.81 42.9096C139.4 43.2896 139.24 44.1696 139.02 44.8396C138.75 45.6396 138.479 46.4396 138.209 47.2396C138.279 47.0596 138.129 46.8396 137.939 46.8396C138.859 47.3196 139.89 47.5596 140.92 47.5296C141.08 47.5296 141.25 47.5096 141.39 47.4296C141.64 47.2796 141.719 46.9496 141.699 46.6596C141.629 45.5496 140.29 44.7296 139.27 45.1596",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M141.058 45.8096C141.598 45.6796 141.888 45.0096 141.738 44.4796C141.588 43.9496 141.098 43.5596 140.568 43.3796C140.038 43.1996 139.468 43.1996 138.918 43.1896",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M144.809 43.7796C145.169 43.7796 145.529 43.7796 145.879 43.7896C145.629 43.6196 145.259 43.7896 145.109 44.0596C144.959 44.3296 144.959 44.6496 144.949 44.9496C144.919 45.7496 144.749 46.5296 144.449 47.2696C144.329 47.5796 143.989 47.9396 143.729 47.7296C143.829 47.6596 143.959 47.6396 144.079 47.6596C143.929 47.6596 143.779 47.6596 143.629 47.6596",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M146.238 43.6596C146.158 43.5396 146.038 43.7796 146.098 43.9196C146.598 45.1796 147.388 46.3196 148.378 47.2396C148.128 47.2696 147.888 47.2996 147.638 47.3296",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M146.929 46.0596C146.219 46.1096 145.519 46.1696 144.809 46.2196",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M148.789 42.8196C148.669 42.9096 148.919 43.0196 149.069 42.9696C149.819 42.6596 150.609 42.3196 151.429 42.3796C152.239 42.4496 153.079 43.0796 153.049 43.8996C153.019 44.6496 152.339 45.1896 151.719 45.6096",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M149.639 42.7296C149.449 42.6396 149.389 42.9996 149.479 43.1896C149.989 44.2796 150.499 45.3696 151.009 46.4596C151.169 46.4196 151.309 46.3196 151.399 46.1796C151.059 46.2796 150.709 46.3796 150.369 46.4896C150.789 46.4196 151.209 46.3396 151.629 46.2696",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M155.838 38.7696C155.078 38.4596 154.249 39.2196 154.109 40.0196C153.899 41.2496 154.968 42.5396 156.218 42.5696C157.468 42.5996 158.588 41.3696 158.448 40.1196C158.298 38.8796 156.918 37.9396 155.708 38.2596",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M158.319 34.3596C157.759 34.3296 157.189 34.7596 157.109 35.3196C157.029 35.8796 157.489 36.4696 158.059 36.4796C158.459 36.4896 158.809 36.2596 159.189 36.1296C159.569 35.9996 159.989 35.9896 160.349 36.1496C160.709 36.3196 160.989 36.6796 160.989 37.0796C160.979 37.6996 160.369 38.1096 159.829 38.4096",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M111.099 0.849609H55.9492V55.9996H111.099V0.849609Z",
    fill: "#FFC9C9"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9184 6.44963C87.0484 7.31963 88.4983 7.64963 89.8883 7.35963C92.0483 6.90963 94.2483 7.96963 95.2483 9.93963C95.8883 11.2096 97.0483 12.1396 98.4383 12.4796C100.588 13.0096 102.108 14.9196 102.148 17.1296C102.178 18.5496 102.818 19.8896 103.918 20.7996C105.618 22.2096 106.168 24.5896 105.238 26.5996C104.648 27.8896 104.648 29.3796 105.238 30.6696C106.158 32.6796 105.618 35.0596 103.918 36.4696C102.818 37.3796 102.178 38.7196 102.148 40.1396C102.108 42.3496 100.588 44.2596 98.4383 44.7896C97.0583 45.1296 95.8883 46.0596 95.2483 47.3296C94.2583 49.2996 92.0583 50.3596 89.8883 49.9096C88.4983 49.6196 87.0484 49.9496 85.9184 50.8196C84.1684 52.1696 81.7283 52.1696 79.9683 50.8196C78.8383 49.9496 77.3883 49.6196 75.9983 49.9096C73.8383 50.3596 71.6383 49.2996 70.6383 47.3296C69.9983 46.0596 68.8383 45.1296 67.4483 44.7896C65.2983 44.2596 63.7783 42.3496 63.7383 40.1396C63.7083 38.7196 63.0683 37.3796 61.9683 36.4696C60.2683 35.0596 59.7183 32.6796 60.6483 30.6696C61.2383 29.3796 61.2383 27.8896 60.6483 26.5996C59.7283 24.5896 60.2683 22.2096 61.9683 20.7996C63.0683 19.8896 63.7083 18.5496 63.7383 17.1296C63.7783 14.9196 65.2983 13.0096 67.4483 12.4796C68.8283 12.1396 69.9983 11.2096 70.6383 9.93963C71.6283 7.96963 73.8283 6.90963 75.9983 7.35963C77.3883 7.64963 78.8383 7.31963 79.9683 6.44963C81.7183 5.09963 84.1584 5.09963 85.9184 6.44963Z",
    fill: "#FF6B6B"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1386 13.5096C80.7486 13.4796 80.3485 13.4496 79.9685 13.5696C79.2085 13.8196 78.7886 14.5996 78.2986 15.2296C77.5086 16.2296 76.3885 16.9196 75.5685 17.8896C74.7485 18.8596 74.2585 20.3396 74.9885 21.3896C74.3585 21.8296 73.9985 22.6396 74.1085 23.3996C74.2185 24.1596 74.7886 24.8396 75.5186 25.0796C74.5986 25.7096 74.6885 27.2196 75.4885 27.9896C76.2885 28.7596 77.5185 28.9096 78.6185 28.6996C78.4285 30.8396 76.9985 32.6296 75.5985 34.2596C74.8985 35.0696 74.1886 35.8896 73.7886 36.8796C73.3886 37.8696 73.3686 39.0796 74.0186 39.9296C74.8086 40.9796 76.2885 41.1596 77.5985 41.2496C79.9885 41.4196 82.3886 41.5996 84.7786 41.7696C86.9386 41.9296 89.2286 42.0596 91.1486 41.0596C91.2186 41.0196 91.2985 40.9796 91.3285 40.8996C91.3885 40.7496 91.2485 40.5996 91.1185 40.4996C89.7785 39.4296 88.6585 38.0896 87.8285 36.5896C87.6885 36.3396 87.5486 36.0696 87.2986 35.9396C86.7086 35.6096 86.0285 36.1996 85.3485 36.2396C84.7985 36.2696 84.2886 35.8996 83.9986 35.4296C83.7186 34.9596 83.6285 34.3996 83.5885 33.8496C83.4985 32.5496 83.6486 31.2396 84.0486 29.9996C84.0986 29.8396 84.1586 29.6696 84.2786 29.5396C84.6486 29.1396 85.3085 29.3596 85.8585 29.3796C86.9185 29.4096 87.7885 28.5696 88.3685 27.6896C88.9385 26.7996 89.3686 25.7896 90.1686 25.0996C89.3586 24.3296 89.1786 23.1096 89.1386 21.9896C89.0986 20.8696 89.1486 19.6896 88.6286 18.6996C89.8486 18.1496 90.4086 16.4696 89.7486 15.2896C89.0886 14.1196 87.3686 13.7096 86.2586 14.4696C86.1186 13.9796 85.9885 13.4896 85.8185 13.0096C84.9985 14.4696 82.5286 13.6296 81.1386 13.5096Z",
    fill: "#FFC9C9"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M82.939 48.7696C94.0675 48.7696 103.089 39.7481 103.089 28.6196C103.089 17.4911 94.0675 8.4696 82.939 8.4696C71.8104 8.4696 62.7891 17.4911 62.7891 28.6196C62.7891 39.7481 71.8104 48.7696 82.939 48.7696Z",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.25 0.25"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7686 18.6396C89.0586 19.4096 89.2085 20.2296 89.1885 21.0596C89.1685 21.8596 89.0085 22.6896 89.3385 23.4196C89.5985 23.9996 90.1485 24.4596 90.2185 25.0896C89.7385 25.2696 89.1685 25.5996 89.2085 26.1096C89.2185 26.2496 89.2886 26.3896 89.2986 26.5296C89.3186 26.7796 89.1786 26.9996 89.0386 27.2096C88.6786 27.7596 88.3185 28.3096 87.9485 28.8596C87.8685 28.9796 87.7786 29.1096 87.6486 29.1796C87.5386 29.2396 87.4086 29.2496 87.2886 29.2496C86.8286 29.2696 86.3586 29.2996 85.8986 29.3196C85.1886 29.3596 84.2786 29.2696 84.0586 28.5896",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4688 22.7196C86.9288 22.0496 87.5488 21.4896 88.2588 21.0896",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M87.84 22.6096C87.81 22.3996 88.1001 22.2296 88.2701 22.3496",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0098 26.6096C88.3398 26.6996 88.6898 26.7396 89.0398 26.7396C88.6998 26.6996 88.3598 26.6596 88.0098 26.6096Z",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3295 17.4496C88.5495 18.2796 88.3295 19.1996 87.7695 19.8496C87.2095 20.4996 86.3195 20.8296 85.4695 20.7296C85.6195 21.1396 85.4895 21.6396 85.1595 21.9396C84.8295 22.2396 84.3196 22.2996 83.9296 22.0896C84.0196 22.7296 83.7495 23.4096 83.2295 23.7996C82.7195 24.1896 81.9895 24.2796 81.3995 24.0196C81.5595 24.8996 80.8196 25.8296 79.9296 25.8696C79.7996 25.8796 79.6596 25.8696 79.5596 25.9596C79.4396 26.0696 79.4695 26.2696 79.4895 26.4296C79.5595 27.1096 79.2195 27.8196 78.6395 28.1896C78.0595 28.5596 77.2695 28.5696 76.6895 28.2196",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6695 15.0696C86.0995 14.8196 85.4194 15.1996 85.0694 15.7196C84.7294 16.2396 84.6195 16.8796 84.4195 17.4696C84.2195 18.0596 83.8695 18.6696 83.2795 18.8796C82.5395 19.1396 81.5795 18.7296 81.0195 19.2696C80.2995 19.9596 81.0195 21.5196 80.1595 22.0196C79.3995 22.4596 78.3495 21.4296 77.6095 21.9096C76.7495 22.4696 77.5395 24.2396 76.5895 24.6396C76.3995 24.7196 76.1795 24.7096 75.9695 24.7496C75.0295 24.9096 74.5095 26.1196 74.9095 26.9896C75.3095 27.8596 76.3794 28.2896 77.3194 28.1296",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M86.75 14.8796C87.14 14.3096 88.02 14.2196 88.62 14.5696C89.22 14.9196 89.5599 15.5996 89.6899 16.2896C89.8399 17.0996 89.61 18.1296 88.83 18.3996",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5 14.6196C86.5 13.7296 86.23 12.8296 85.74 12.0796C85.79 12.4196 85.83 12.7696 85.88 13.1096C85.91 13.3496 85.94 13.6296 85.78 13.8096C85.54 14.0796 85.07 13.9396 84.83 13.6696C84.59 13.3996 84.48 13.0296 84.25 12.7496C84.48 13.4896 84.63 14.4496 84 14.8996C84.08 14.8396 84.16 14.7896 84.24 14.7296",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5502 21.8496C75.0702 21.3396 76.0002 21.3096 76.5502 21.7996C76.1402 21.6596 75.7302 21.5096 75.3002 21.5196C74.8702 21.5296 74.4101 21.7196 74.2201 22.1096C74.1201 22.2896 74.1001 22.5096 74.0901 22.7096C74.0801 23.3996 74.3501 24.0996 74.8301 24.5996C75.1201 24.9096 75.6902 25.1096 75.9202 24.7496",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2594 20.9796C73.9594 20.9996 73.6594 20.7696 73.6094 20.4696C74.1594 20.5396 74.7094 20.6196 75.2594 20.6896C75.4194 20.7096 75.5894 20.7296 75.7394 20.6696C75.9494 20.5796 76.0694 20.3596 76.1694 20.1496C76.3394 19.7796 76.4693 19.3996 76.5693 19.0096C76.5293 19.3696 76.9094 19.6796 77.2694 19.6496C77.6294 19.6196 77.9194 19.3296 78.0494 18.9896C78.1794 18.6496 78.1694 18.2796 78.1194 17.9196C78.5694 18.3196 79.2594 18.4196 79.7994 18.1696C80.3394 17.9196 80.7093 17.3296 80.6993 16.7296C81.0593 17.0796 81.7194 16.8696 81.9694 16.4296C82.2194 15.9896 82.1594 15.4496 82.0394 14.9596C82.6794 15.4896 83.8194 15.1496 84.0494 14.3496",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8002 20.4796C74.5102 19.5596 74.7901 18.5296 75.3201 17.7196C75.8501 16.9096 76.6001 16.2796 77.3401 15.6596C77.8601 15.2196 78.3902 14.7796 78.9102 14.3396C79.3502 13.9696 79.8302 13.5796 80.4102 13.5396C80.8202 13.5096 81.2201 13.6596 81.6201 13.6596C82.0001 13.6596 82.3702 13.5296 82.7502 13.4796C83.1302 13.4296 83.5602 13.4696 83.8102 13.7596",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8595 28.9896C84.0795 29.7896 83.6195 30.9096 83.6195 32.0296C83.6195 33.1496 83.5295 35.4896 86.3595 36.9096",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9696 28.2696C78.7396 29.4396 78.4796 30.6596 77.7396 31.5796C77.3596 32.0496 76.8597 32.4296 76.4297 32.8596C75.1997 34.0996 74.5497 35.7896 73.9297 37.4196",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0098 37.4896C74.5898 38.4096 76.5797 37.9496 78.3397 37.4596C79.9697 37.0096 81.6097 36.5496 83.2397 36.0996C83.5297 36.0196 83.8198 35.9396 84.1198 35.9296C85.0498 35.9096 86.0797 36.5596 86.8297 36.0096",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3391 36.4996C84.3591 36.9396 82.4391 37.6196 80.6191 38.5196",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0085 36.9696C84.3985 36.9696 83.1286 38.2396 81.7786 39.1096C80.7086 39.7996 79.4885 40.2696 78.2285 40.4796",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0293 35.8996C88.0993 36.5996 88.8693 37.7296 89.1093 38.9796C89.8093 39.2396 90.4393 39.7196 90.8693 40.3396",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0684 40.7196C84.9484 40.0196 86.8784 39.4396 88.8384 38.9796",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7991 24.4996C87.5991 25.4396 87.409 26.3796 87.209 27.3196",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2389 40.4896C94.1989 40.6196 94.1689 40.7596 94.1289 40.8896C94.1889 40.9296 94.239 40.9796 94.299 41.0196C94.479 40.9496 94.5789 40.7296 94.5089 40.5496C94.4289 40.5596 94.349 40.5296 94.299 40.4796C94.229 40.5296 94.179 40.6096 94.179 40.6896C94.199 40.6196 94.2189 40.5496 94.2389 40.4896Z",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8594 39.8996C69.8994 40.0696 70.1994 40.0596 70.2194 39.8796C70.1894 39.7996 70.0694 39.7696 69.9994 39.8296",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6095 11.8996C88.6395 12.0996 88.7095 12.2996 88.8495 12.4496C89.0495 12.6596 89.3695 12.7296 89.6495 12.6696C89.9295 12.6096 90.1795 12.4396 90.3695 12.2196C90.8395 11.6896 90.9595 10.4596 90.0595 10.2596C89.2095 10.0696 88.5195 11.1796 88.6095 11.8996Z",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M92.449 11.6796C92.419 11.4996 92.299 11.3496 92.129 11.2896C92.319 11.5196 92.499 11.7496 92.689 11.9796C92.609 11.9196 92.5591 11.8396 92.5291 11.7496C92.1191 12.3096 91.7091 12.8596 91.2891 13.4196",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4785 11.8696C92.8685 11.8996 93.2385 12.0796 93.4985 12.3696",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7793 13.0896C92.4993 12.9196 92.2292 12.7396 91.9492 12.5696",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0684 13.6696C95.2584 13.7896 95.4384 13.9396 95.5684 14.1196C95.7484 14.3696 95.9284 14.7096 96.2384 14.7196",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5397 14.2796C95.0597 14.7396 94.5796 15.1996 94.0996 15.6596",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M97.01 15.4496C96.4 15.9096 95.81 16.3996 95.25 16.9196",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1191 16.2096C96.3791 16.3096 96.5292 16.5796 96.6692 16.8096C96.8192 17.0496 97.0292 17.2896 97.3092 17.2896",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0801 18.0596C96.8001 17.6496 97.5002 17.1996 98.1702 16.7196",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7793 19.3396C97.5793 18.9996 98.3293 18.5596 99.0293 18.0396C99.1593 18.3496 99.3293 18.6496 99.5193 18.9296",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1992 18.7796C98.3992 19.0596 98.5592 19.3596 98.6992 19.6796",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1992 19.2596C97.3492 19.5896 97.5093 19.9296 97.6593 20.2596",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3496 22.7096C99.0896 22.3796 99.8697 22.1296 100.66 21.9596",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M100.579 21.7596C100.739 21.9796 100.85 22.2396 100.92 22.4996C100.99 22.7596 100.98 23.0996 100.75 23.2396C100.65 23.2996 100.52 23.3096 100.4 23.2896C99.9595 23.2396 99.5695 22.9096 99.4395 22.4896",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M99.549 22.4296C99.679 22.6296 99.7789 22.8596 99.8489 23.0896C99.8889 23.2296 99.9089 23.3796 99.8289 23.4996C99.7289 23.6496 99.5189 23.6696 99.3389 23.6296C98.8889 23.5396 98.4989 23.1696 98.3789 22.7296",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8185 24.8396C98.9185 24.7496 99.0685 24.7496 99.2085 24.7596C99.9585 24.8196 100.709 24.9496 101.429 25.1496C100.509 25.4796 99.6286 25.9196 98.8086 26.4596",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7598 24.9096C99.7798 25.1996 99.7997 25.4996 99.8297 25.7896",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0684 27.6096C99.6084 27.5196 100.168 27.5196 100.708 27.6096C101.008 27.6596 101.328 27.7296 101.608 27.5996C101.558 27.5296 101.508 27.4496 101.458 27.3796C101.418 27.4796 101.398 27.5896 101.418 27.6996C101.418 27.5896 101.418 27.4796 101.418 27.3796",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M99 27.6096C99.02 27.7896 99.0499 27.9596 99.0699 28.1396",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M100.049 27.9696C100.109 28.2396 100.139 28.5196 100.119 28.7896",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0098 29.1696C99.8098 29.1696 100.62 29.1796 101.42 29.1796",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M101.47 29.1296C101.5 29.1096 101.45 29.0696 101.42 29.0896C101.39 29.1096 101.4 29.1496 101.4 29.1796C101.42 29.3496 101.45 29.5096 101.49 29.6696",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7383 30.1196C99.2583 30.6996 99.8383 31.2196 100.468 31.6896",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4199 32.0296C99.1199 31.8696 99.8199 31.7596 100.53 31.7096",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2585 30.9696C99.1885 31.2396 99.1286 31.5096 99.0586 31.7896",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1101 32.8796C98.8001 33.1996 99.4601 33.5696 100.08 33.9996C99.4301 34.0296 98.7701 33.9896 98.1201 33.8896C98.5001 34.3996 98.8001 34.9896 98.9701 35.5996C98.4501 35.3896 97.9302 35.1696 97.4102 34.9596",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M96.959 35.5396C97.449 36.2196 97.889 36.9396 98.269 37.6796",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0898 36.9496C96.4298 37.1696 96.8098 37.3296 97.1998 37.4196C97.5198 37.4896 97.8798 37.5196 98.0898 37.7696",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3595 36.6096C97.1095 36.7896 96.9095 37.0296 96.7695 37.3096",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5196 37.9296C95.2696 38.0096 94.9995 38.1496 94.9495 38.3996C94.9095 38.6196 95.0696 38.8496 95.2696 38.9496C95.4696 39.0496 95.7095 39.0696 95.9395 39.0796C96.1295 39.0896 96.3296 39.0996 96.5196 39.1096C96.6996 39.2896 96.7596 39.5896 96.6696 39.8296C96.5696 40.0696 96.3295 40.2496 96.0695 40.2496",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7201 41.1296C91.7001 41.0596 91.6802 40.9996 91.6602 40.9296C92.0202 41.7296 92.4301 42.4996 92.9001 43.2396C92.8201 43.2596 92.7402 43.2796 92.6602 43.3096",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3984 41.2796C91.6084 41.1096 91.8284 40.9596 92.0684 40.8396",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9492 42.0496C90.1392 42.0596 90.3293 42.0096 90.4893 41.9096",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5293 41.9896C90.9393 42.7096 91.3392 43.4396 91.7092 44.1796C91.5792 44.1796 91.4492 44.1796 91.3192 44.1796C91.5992 44.0396 91.8892 43.9296 92.1892 43.8496",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2598 40.2496C72.5098 40.6096 72.8598 40.8996 73.2498 41.0896",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3895 40.4696C72.0095 41.1196 71.5795 41.7396 71.0995 42.3196C70.9895 42.4496 70.7695 42.5696 70.6895 42.4196C71.0895 42.4996 71.4796 42.6796 71.7896 42.9596",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6094 41.7196C71.8794 41.7496 72.1294 41.8796 72.3094 42.0796",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9896 41.5996C73.9696 41.9896 73.7397 42.3396 73.5197 42.6696C73.3597 42.9096 73.1997 43.1496 73.0397 43.3896C72.9597 43.5096 72.8696 43.6296 72.7396 43.6996C72.6096 43.7696 72.4296 43.7496 72.3496 43.6196C72.8396 43.8196 73.3096 44.0696 73.7496 44.3696",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7383 41.4596C73.9283 41.5396 74.0882 41.6696 74.1882 41.8396",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6885 42.6796C75.2285 43.3896 74.7385 44.0896 74.2285 44.7596",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0801 42.3096C75.2901 42.3896 75.4801 42.5296 75.6301 42.6996",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0801 44.6596C74.3101 44.6996 74.5301 44.7796 74.7301 44.8896",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3685 43.2096C76.8585 43.3296 77.3485 43.4596 77.8385 43.5796C77.1385 44.0096 76.4285 44.4496 75.7285 44.8796C76.1585 45.0996 76.5785 45.3296 77.0085 45.5496",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3691 46.1896C77.6991 45.3496 78.7891 44.9196 78.9391 44.0296C79.0591 44.9096 79.2391 45.7796 79.4691 46.6396",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2598 45.2096C78.5498 45.2196 78.8498 45.2396 79.1398 45.2496",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3086 44.1396C80.8286 44.0696 81.3786 44.2096 81.7886 44.5296C81.8286 44.5596 81.8785 44.5996 81.8885 44.6496C81.9185 44.7496 81.8486 44.8396 81.7686 44.9096C81.4886 45.1596 81.1085 45.2996 80.7285 45.3096C81.0985 45.3096 81.5185 45.3796 81.7385 45.6796C81.9385 45.9596 81.8585 46.3996 81.5685 46.5996C81.2885 46.7996 80.8486 46.7196 80.6486 46.4296",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9001 44.1896C82.9501 44.9496 82.9301 45.7096 82.8301 46.4696C83.2201 46.5296 83.6201 46.4596 83.9601 46.2596",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8984 45.2396C83.2084 45.1796 83.5284 45.1596 83.8384 45.1896",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8398 44.0296C83.2098 44.0696 83.5798 44.1296 83.9498 44.2096",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3691 44.0196C84.9991 44.0696 85.6391 44.0096 86.2491 43.8196",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3594 44.0696C85.4994 44.7496 85.6494 45.4396 85.7894 46.1196",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7285 43.6596C86.7885 44.3696 86.8685 45.0696 86.9885 45.7796",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M86.959 44.6796C87.509 44.5796 88.0391 44.4096 88.5391 44.1796",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8789 43.1996C88.1689 43.9396 88.4489 44.6796 88.7389 45.4196",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5391 45.4796C88.7291 45.4596 88.909 45.3996 89.069 45.3096",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M80.269 44.4296C80.279 44.3796 80.2891 44.3196 80.2991 44.2696C80.1891 45.0196 80.159 45.7796 80.209 46.5396",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1984 38.1296C67.1784 38.0796 67.0884 38.0796 67.0684 38.1296C67.3984 38.6596 67.7685 39.1596 68.1685 39.6296",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6797 38.8596C68.3597 38.5796 69.0096 38.2096 69.5996 37.7596C69.5796 37.7096 69.5396 37.6796 69.4896 37.6696",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3789 37.4296C69.4989 37.5896 69.6189 37.7396 69.7289 37.8996",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3691 37.2996C67.1591 36.9096 67.9391 36.5096 68.7291 36.1196C68.6091 36.0996 68.5091 36.0196 68.4491 35.9096C68.5991 36.1196 68.7492 36.3296 68.9092 36.5396",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0189 35.8196C67.0489 35.8196 67.0589 35.7696 67.0289 35.7496C66.9989 35.7396 66.9689 35.7796 66.9889 35.7996C67.1289 35.9796 67.2589 36.1696 67.3789 36.3696",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4883 36.1296C66.2783 35.7096 67.0783 35.2996 67.8683 34.8796C67.9483 34.8396 68.0282 34.7896 68.0682 34.7096C68.0982 34.6296 68.0583 34.5096 67.9683 34.5196",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8984 33.1996C64.9784 33.6296 65.1085 34.0496 65.2985 34.4396C66.0485 34.1596 66.8084 33.9196 67.5784 33.7096C67.3184 33.3596 67.0885 32.9796 66.9185 32.5796",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7383 33.3696C65.8183 33.5296 65.8983 33.6796 65.9783 33.8396",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3801 29.1796C64.1401 29.1596 63.9301 29.3796 63.9101 29.6196C63.8901 29.8596 64.03 30.0896 64.22 30.2296C64.41 30.3696 64.6601 30.4296 64.8901 30.4496C65.3001 30.4896 65.7501 30.4296 66.0601 30.1496C66.3601 29.8696 66.4401 29.3196 66.1301 29.0496",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7894 27.7696C64.1194 28.3496 64.9293 28.4896 65.5793 28.3096C65.9393 28.2096 66.3394 27.9696 66.3594 27.5896C66.3694 27.4396 66.3094 27.2896 66.2494 27.1596C65.9494 26.5896 65.0894 25.9796 64.3994 26.1696C63.7794 26.3596 63.4794 27.2296 63.7894 27.7696Z",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9785 24.9896C64.8185 25.1396 65.6485 25.2996 66.4885 25.4496C66.5185 25.3796 66.4686 25.2896 66.3986 25.2696C66.3686 25.3996 66.3785 25.5496 66.4485 25.6696C66.4285 25.5396 66.3985 25.3996 66.3785 25.2696",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0195 24.9996C64.6695 24.8096 65.2895 24.5196 65.8495 24.1396C65.3995 23.6296 64.9295 23.1496 64.4395 22.6796C64.8695 22.6996 65.2595 22.9296 65.6495 23.0996C66.0395 23.2796 66.4995 23.4096 66.8995 23.2396",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8496 23.0296C66.8496 23.1496 66.8496 23.2696 66.8496 23.3796",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M67.12 22.2496C67.07 22.2996 67.15 22.4096 67.21 22.3696C67.27 22.3296 67.22 22.2096 67.15 22.2296C67.11 22.2696 67.07 22.3096 67.03 22.3496C67.06 22.2796 67.1 22.2096 67.13 22.1296C66.99 22.2696 66.76 22.0996 66.63 21.9496C66.2 21.4796 65.62 21.1396 65 20.9996C65.81 21.1496 66.65 21.1696 67.47 21.0596C66.89 20.3696 66.32 19.6696 65.75 18.9596C66.58 18.9496 67.08 20.0496 67.91 20.0596C67.98 20.0096 68.06 19.9596 68.13 19.9096C68.03 20.0196 67.94 20.1396 67.84 20.2496",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0693 17.4796C67.0993 17.8296 67.3294 18.1396 67.5594 18.3996C67.9194 18.7896 68.4393 19.1596 68.9393 18.9796C69.3293 18.8396 69.5393 18.3796 69.4793 17.9696C69.4193 17.5596 69.1294 17.2096 68.7794 16.9896C68.2094 16.6196 66.9593 16.3396 67.0693 17.4796Z",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1384 17.1996C70.2884 17.0396 70.4384 16.8796 70.5884 16.7196C70.4984 16.7896 70.3985 16.8596 70.3085 16.9296C69.8885 16.2696 69.3884 15.6696 68.8184 15.1296C69.7084 15.4096 70.5984 15.6896 71.5184 15.7796C71.0584 15.1596 70.5884 14.5396 70.1284 13.9096C70.0084 13.9896 69.8784 14.0596 69.7584 14.1396C69.8684 14.0796 69.9784 14.0196 70.0884 13.9596",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6094 13.6196C70.7394 13.4396 70.8994 13.2896 71.0894 13.1696C70.9994 13.2296 70.9193 13.2896 70.8293 13.3496C71.4593 13.6996 72.0894 14.0596 72.7194 14.4096C72.6894 13.7396 72.1794 13.1696 72.1494 12.4996C72.5794 13.0196 73.1094 13.4496 73.7094 13.7696C73.5494 13.0596 73.4193 12.3496 73.3293 11.6196C73.2293 11.6696 73.1294 11.7196 73.0294 11.7696C73.0794 11.7396 73.1294 11.7096 73.1794 11.6796C73.1294 11.7096 73.0694 11.7496 73.0194 11.7796",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1797 11.2196C74.5697 11.7996 74.9696 12.3796 75.3596 12.9596C75.6796 12.8096 75.9997 12.6496 76.3097 12.4996",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5492 11.6696C75.2392 11.7996 74.9291 11.9196 74.6191 12.0496",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1384 10.7796C74.8384 10.7896 74.5484 10.9096 74.3184 11.0996",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2491 12.2696C77.2191 11.4596 77.1691 10.6596 77.1191 9.84961C77.3091 9.95961 77.4591 10.1296 77.6191 10.2796C78.0891 10.7396 78.6292 11.1296 79.1692 11.4996",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3691 11.2696C77.5491 11.1896 77.7192 11.1196 77.8992 11.0396",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3691 9.26962C79.6591 9.28962 79.9591 9.27962 80.2491 9.23962C80.1991 9.36962 79.9592 9.28962 79.8792 9.39962C79.8592 9.42962 79.8491 9.46962 79.8491 9.50962C79.8291 10.1096 80.3091 10.6596 80.2291 11.2596C80.0391 11.2696 79.8592 11.2896 79.6692 11.2996C79.9992 11.3196 80.3292 11.2996 80.6492 11.2496",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7188 11.2096C80.9488 11.1496 81.1888 11.1296 81.4288 11.1596",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4297 9.20959C81.9997 9.24959 82.5696 9.21959 83.1296 9.13959C82.9496 9.22959 82.7497 9.27959 82.5497 9.28959",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2188 9.2796C82.3188 9.8996 82.4088 10.5296 82.5088 11.1496",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8398 9.03961C84.0798 9.08961 84.3099 9.16961 84.5299 9.26961C84.4499 9.27961 84.3599 9.25961 84.2899 9.19961C84.2299 9.93961 84.1799 10.6696 84.1199 11.4096",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3086 10.2496C84.8086 10.1796 85.3185 10.1796 85.8285 10.2496C85.8785 10.2596 85.9085 10.2996 85.9585 10.2996C86.0085 10.2996 85.9485 10.2096 85.9485 10.2596",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9095 9.3996C85.7595 10.0296 85.6094 10.6696 85.4594 11.2996C85.4394 11.3896 85.4195 11.4896 85.4795 11.5596C85.4995 11.4896 85.5295 11.4096 85.5495 11.3396",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0782 9.2296C85.9682 9.2496 85.8583 9.2696 85.7383 9.2896C85.8783 9.2596 86.0183 9.23959 86.1683 9.20959C86.0383 9.22959 85.9083 9.2496 85.7783 9.2796",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5801 38.0796C73.7401 38.7696 74.0201 39.4396 74.3901 40.0496C74.4001 39.9996 74.4202 39.9496 74.4302 39.8996",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4395 39.8596C76.8395 41.3096 79.7795 41.4296 82.5795 41.5196C83.6295 41.5496 84.6895 41.5796 85.7395 41.6096C86.3895 41.6296 87.0396 41.6496 87.6696 41.5496C88.8296 41.3696 89.9095 40.7996 91.0695 40.6096",
    stroke: "#FFA8A8",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0502 92.0996L1.33008 109.79",
    stroke: "#FF6B6B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M257.45 117.74L247.33 102.57",
    stroke: "#FF6B6B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M170.5 61.6504H115.35V116.8H170.5V61.6504Z",
    fill: "#FFC9C9"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M142.569 114.68C156.431 114.68 167.669 103.443 167.669 89.5804C167.669 75.7181 156.431 64.4804 142.569 64.4804C128.706 64.4804 117.469 75.7181 117.469 89.5804C117.469 103.443 128.706 114.68 142.569 114.68Z",
    fill: "#FFA8A8"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M133.309 69.9004C132.009 72.6404 129.649 74.8604 126.839 76.0004C127.859 75.3304 128.969 74.7904 130.139 74.4204C128.899 77.0904 127.429 79.9904 124.699 81.1204C124.239 81.3104 123.739 81.4504 123.329 81.7404C122.919 82.0304 122.609 82.5304 122.719 83.0204C123.539 82.5204 124.239 81.8304 124.759 81.0304C125.159 81.0604 125.229 81.6804 124.959 81.9804C124.689 82.2804 124.269 82.3704 123.919 82.5704C122.909 83.1404 122.649 84.4504 122.489 85.6004C122.929 84.4104 123.789 83.3804 124.869 82.7204C125.129 84.6904 124.819 86.7304 123.989 88.5404C123.189 90.2904 121.879 92.1704 122.589 93.9604C122.999 93.1904 123.229 92.3204 123.239 91.4504C123.329 91.1304 123.879 91.2204 123.999 91.5404C124.119 91.8504 123.969 92.2004 123.819 92.5004C123.449 93.2504 123.079 94.0004 122.709 94.7504C123.449 95.7404 124.189 96.7304 124.919 97.7104C124.009 96.2104 123.829 94.2804 124.429 92.6304C125.619 93.8704 126.449 95.4604 126.789 97.1404C127.069 98.4904 127.039 99.8804 127.289 101.24C127.539 102.59 128.139 103.98 129.309 104.7C128.869 104.04 128.709 103.21 128.859 102.43C128.589 102.51 128.259 102.3 128.229 102.02C128.189 101.74 128.449 101.45 128.739 101.46C129.329 101.48 129.379 102.33 129.379 102.92C129.379 104.69 130.959 106.31 132.729 106.34C131.499 105.43 130.639 104.02 130.399 102.51C132.509 103.42 134.499 104.59 136.319 105.99C137.039 106.54 137.799 107.28 137.709 108.18C138.229 108.16 138.749 108.25 139.229 108.43C138.729 107.9 138.229 107.38 137.729 106.85C137.529 106.64 137.339 106.26 137.589 106.1C137.839 105.95 138.089 106.28 138.219 106.53C139.299 108.63 141.979 109.2 144.309 109.54",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M158.089 74.5804C157.659 71.5404 154.579 69.1404 151.529 69.4704C152.829 72.2104 155.399 74.3204 158.339 75.0504C157.259 74.4604 155.989 74.2404 154.769 74.4204C155.759 76.8704 157.769 78.9004 160.219 79.8904C160.769 80.1104 161.349 80.2904 161.819 80.6404C162.299 80.9904 162.659 81.5704 162.559 82.1504C162.239 81.7504 161.729 81.5004 161.219 81.5104C161.419 81.0204 161.189 80.3904 160.719 80.1404C160.179 80.1304 160.059 80.9904 160.429 81.3804C160.799 81.7804 161.369 81.8904 161.839 82.1604C163.059 82.8804 163.289 84.5304 163.379 85.9504C163.129 84.2704 161.839 82.7904 160.219 82.3104C160.479 84.6104 160.779 87.0004 162.059 88.9304C162.839 90.1104 164.029 91.2704 163.829 92.6704C163.249 92.5004 163.069 91.7904 162.939 91.2004C162.809 90.6104 162.479 89.9104 161.879 89.9204C161.559 90.9404 162.749 91.7604 163.159 92.7504C163.389 93.2904 163.369 93.9004 163.309 94.4904C163.159 96.0904 162.729 97.6604 162.059 99.1304C162.319 97.9504 162.589 96.7504 162.529 95.5504C162.469 94.3404 162.029 93.1104 161.099 92.3304C160.429 94.6004 160.099 96.9704 160.119 99.3404C160.139 101.04 160.129 103.13 158.619 103.91C158.649 103.15 158.689 102.38 158.719 101.62C158.729 101.32 158.699 100.94 158.419 100.82C158.079 100.68 157.739 101.12 157.779 101.49C157.819 101.86 158.059 102.17 158.189 102.52C158.459 103.26 158.129 104.17 157.439 104.56",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M158.749 74.7504C158.209 74.0604 157.959 73.1304 158.089 72.2604C161.079 73.6904 163.049 77.0104 162.859 80.3204C162.819 81.0804 162.739 82.0104 163.359 82.4504C163.459 81.3804 163.549 80.3204 163.649 79.2504C164.139 79.3004 164.379 79.9104 164.289 80.4004C164.199 80.8804 163.899 81.3104 163.759 81.7804C163.319 83.2704 164.519 84.7604 164.539 86.3104C164.259 85.0104 164.389 83.6404 164.879 82.4104C165.989 83.7004 166.509 85.4804 166.269 87.1604C165.919 89.6004 164.079 91.7304 164.169 94.2004C164.909 93.9704 165.489 93.3204 165.629 92.5604C165.669 92.3504 165.689 92.1104 165.849 91.9704C166.189 91.6604 166.749 92.1904 166.659 92.6404C166.569 93.0904 166.149 93.3904 165.799 93.7004C164.519 94.8104 163.889 96.4804 163.299 98.0804C163.979 97.1504 164.999 96.4704 166.119 96.2004C166.019 98.5504 164.719 100.82 162.739 102.09C161.149 103.11 159.029 103.64 158.219 105.35C159.089 105.11 159.959 104.88 160.829 104.64C161.039 105.05 160.689 105.57 160.249 105.73C159.819 105.89 159.339 105.81 158.869 105.78C157.399 105.68 155.899 106.1 154.689 106.94C156.449 106.67 158.279 106.91 159.909 107.62C158.349 108.82 156.309 109.15 154.369 109.43C153.689 109.53 152.999 109.63 152.329 109.5C151.819 109.4 151.339 109.18 150.849 109.03C150.029 108.78 149.139 108.74 148.299 108.91C148.799 109.72 149.699 110.27 150.649 110.35C150.869 110.37 151.119 110.37 151.289 110.51C151.769 110.9 151.009 111.68 150.429 111.49C149.839 111.3 149.519 110.7 149.079 110.26C147.969 109.17 145.899 109.35 144.999 110.61C145.799 110.42 146.699 110.94 146.929 111.73C146.779 112.05 146.299 112.06 145.999 111.87C145.699 111.68 145.489 111.37 145.209 111.16C144.639 110.75 143.839 110.81 143.209 111.12C142.579 111.43 142.089 111.96 141.619 112.47C141.659 112.14 141.699 111.82 141.729 111.49",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M152.48 107.03C153.81 106.42 155.14 105.69 156.08 104.57C157.02 103.44 157.5 101.84 156.98 100.47C156.04 101.7 154.54 102.34 153.29 103.25C151.56 104.5 150.26 106.33 149.65 108.37C149.27 108.19 148.82 108.15 148.41 108.26C148.7 107.85 149.01 107.41 149.04 106.9C149.08 106.4 148.72 105.83 148.22 105.83C147.56 106.05 147.64 107.23 148.33 107.36C147.87 108.22 146.8 108.49 145.88 108.79C144.56 109.21 143.32 109.86 142.22 110.7C141.69 111.11 141.18 111.57 140.86 112.16C140.8 112.27 140.69 112.41 140.57 112.36C140.45 112.31 140.65 112.1 140.65 112.23",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M132.819 69.9104C129.669 70.2904 126.919 72.9404 126.439 76.0804C126.659 75.0004 126.739 73.8804 126.689 72.7804C123.459 75.1204 121.599 79.2204 121.959 83.2004C121.769 82.5304 121.579 81.8704 121.389 81.2004C121.289 80.8404 121.099 80.4104 120.729 80.3904C120.349 80.3704 120.109 80.8504 120.189 81.2204C120.269 81.5904 120.549 81.8804 120.779 82.1904C121.489 83.1204 121.799 84.3204 121.739 85.4904C121.429 84.4304 120.749 83.4804 119.839 82.8404C119.019 85.7304 119.429 88.9504 120.949 91.5404C121.589 92.6304 122.439 93.9004 121.889 95.0404C121.509 94.4504 121.129 93.8604 120.759 93.2804C120.679 93.1604 120.599 93.0304 120.489 92.9504C119.929 92.5304 119.179 93.4604 119.459 94.1004C119.739 94.7404 120.489 95.0004 121.169 95.1904C122.549 96.6704 123.769 98.3104 124.789 100.05C123.789 98.9804 122.459 98.2204 121.019 97.9004C121.579 99.8304 122.619 101.61 124.019 103.05C124.549 103.6 125.159 104.11 125.879 104.36C126.489 104.57 127.159 104.59 127.779 104.79C128.399 104.98 129.009 105.44 129.079 106.09C128.419 106.14 127.739 105.85 127.319 105.34C126.699 105.32 126.509 106.3 126.939 106.74C127.369 107.18 128.069 107.21 128.679 107.21C130.149 107.21 131.619 107.21 133.089 107.2C131.509 107.03 129.869 107.59 128.729 108.69C130.209 110.38 132.839 110.93 134.879 109.97C135.559 109.65 136.169 109.19 136.879 108.97C137.589 108.75 138.489 108.85 138.909 109.48C137.769 109.91 136.709 110.52 135.759 111.29C135.809 111.83 136.629 111.9 137.049 111.56C137.469 111.22 137.659 110.67 138.059 110.3C139.089 109.35 140.729 110.04 141.929 110.77",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M135.148 95.1604C135.148 96.5304 135.148 97.9004 135.148 99.2704",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M133.979 99.3904C134.709 99.5304 135.468 99.5704 136.208 99.5104",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M133.918 95.2804C134.708 95.2504 135.508 95.2104 136.298 95.1804C136.648 95.1604 137.038 95.1604 137.318 95.3704C137.878 95.7804 137.628 96.7504 137.038 97.1104C136.448 97.4704 135.698 97.4004 135.008 97.3204",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M139.148 94.6904C140.208 94.7504 141.278 94.7404 142.338 94.6404C142.258 94.9804 142.338 95.3604 142.548 95.6404",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M139.938 94.8104C139.988 95.3604 140.048 95.9204 140.098 96.4704C140.148 97.0204 140.208 97.5904 140.038 98.1204C139.878 98.6504 139.448 99.1304 138.898 99.1904",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M140.209 97.3004C140.789 97.1704 141.379 97.1304 141.969 97.1704",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M141.85 96.4604C141.85 96.8904 141.85 97.3204 141.85 97.7504",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M139.029 99.0204C140.199 99.0604 141.369 99.1104 142.549 99.1504C142.569 98.9004 142.659 98.6704 142.789 98.4604",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M142.809 98.2304C142.579 98.6204 142.349 99.0204 142.119 99.4104",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M147.239 94.2204C147.119 94.6804 147.089 95.1604 147.149 95.6304",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M147.129 95.1804C146.299 94.8804 145.249 94.6104 144.629 95.2404C144.549 95.3204 144.468 95.4204 144.448 95.5404C144.398 95.7404 144.489 95.9404 144.619 96.1004C144.929 96.5004 145.409 96.7004 145.869 96.9004C146.329 97.1004 146.809 97.3204 147.099 97.7304C147.389 98.1404 147.368 98.8004 146.938 99.0604C146.728 99.1804 146.479 99.1904 146.239 99.1804C145.489 99.1504 144.739 98.9604 144.059 98.6304C144.219 98.8904 144.318 99.2004 144.328 99.5104",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M150.91 94.9504C149.95 95.0204 149.39 96.1404 149.45 97.1104C149.48 97.6304 149.65 98.1704 150 98.5504C150.35 98.9404 150.92 99.1504 151.42 99.0004C152.23 98.7604 152.52 97.7804 152.62 96.9404",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M150.668 95.0504C151.288 94.9804 151.928 95.2504 152.308 95.7504C152.688 96.2404 152.778 96.9404 152.548 97.5204",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M138.209 102.57C138.589 102.16 139.019 101.79 139.499 101.49C139.259 102.66 139.159 103.85 139.209 105.04",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M142.309 101.99C141.889 101.59 141.119 101.67 140.799 102.15C140.479 102.63 140.709 103.38 141.239 103.61C141.769 103.84 142.469 103.47 142.589 102.9",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M142.38 101.94C142.27 102.52 142.4 103.13 142.31 103.72C142.22 104.31 141.77 104.93 141.18 104.87",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M143.379 101.74C144.029 101.79 144.689 101.77 145.339 101.67C144.419 102.4 143.809 103.52 143.689 104.69",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M147.968 101.15C147.528 101.07 147.048 101.34 146.908 101.76C146.768 102.18 146.958 102.69 147.348 102.9C146.748 102.97 146.338 103.7 146.558 104.26C146.778 104.82 147.528 105.1 148.068 104.84C148.618 104.58 148.888 103.87 148.688 103.3C148.568 102.94 148.238 102.62 147.858 102.62C148.248 102.49 148.518 102.07 148.458 101.66C148.398 101.25 148.028 100.92 147.618 100.9",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M158.889 75.5404C158.599 75.3004 158.319 75.0604 158.029 74.8304C159.479 76.4804 160.769 78.2704 161.879 80.1604",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M151.758 69.2304C153.798 70.1404 155.588 71.6304 156.848 73.4804",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M128.029 73.6904C129.309 72.0504 131.059 70.7804 133.019 70.0704",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M123.969 79.7604C124.799 78.4304 125.919 77.2804 127.229 76.4104",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M123.949 83.8704C123.039 86.0704 122.519 88.4404 122.439 90.8204",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M119.93 83.1804C120.31 85.2904 120.84 87.3704 121.52 89.4004",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M121.578 97.7004C122.998 99.3704 124.378 101.09 125.708 102.84",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M125.999 99.5104C125.319 97.6404 124.629 95.7604 123.949 93.8904",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M129.628 108.7C129.558 108.76 129.538 108.88 129.598 108.95C131.618 108.28 133.958 108.96 135.848 107.98",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M160.588 100.94C161.358 98.5904 161.718 96.1104 161.648 93.6404",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M160.43 83.3304C160.39 83.4004 160.31 83.2404 160.39 83.2104C160.47 83.1904 160.54 83.2804 160.58 83.3504C161.79 85.5104 162.74 87.8204 163.38 90.2104",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M158.508 72.8904C160.138 75.2204 161.348 77.8404 162.078 80.5804",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M151.639 107.57C152.359 106.43 153.209 105.37 154.159 104.41C155.159 103.4 156.279 102.49 157.069 101.31",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M153.369 107.85C155.139 107.92 156.919 107.83 158.669 107.6",
    stroke: "#FF6B6B",
    strokeWidth: 0.9482,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M139 74.3904C139.64 74.2204 140.32 74.6004 140.7 75.1404C141.08 75.6804 141.22 76.3504 141.34 77.0004C141.99 80.5004 142.24 84.0804 142.09 87.6404C142.06 88.3304 142.01 89.0404 141.73 89.6704C141.13 91.0004 139.66 91.6704 138.26 92.0804C141.51 92.4404 144.9 90.9304 147.98 92.0204C146.48 91.4004 145.43 89.9704 144.88 88.4504C144.33 86.9304 144.22 85.2804 144.14 83.6504C143.94 79.6604 143.85 75.6604 143.88 71.6704C143.9 68.9804 143.41 69.8804 142.36 71.5804C141.66 72.7204 140.37 74.0304 139 74.3904Z",
    fill: "#FF6B6B",
    stroke: "#FF6B6B",
    strokeWidth: 1.2642,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M254.5 31.5L240.5 46.5",
    stroke: "#FF6B6B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M258.5 47.5L246.5 49.5",
    stroke: "#FF6B6B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectingRightImage);
export default __webpack_public_path__ + "static/media/collectingRightImage.2be4da5544277173857d825a481f4545.svg";
export { ForwardRef as ReactComponent };